if (typeof Swiper !== "undefined") {
  const heroSwiperEl = document.querySelector(".hero-swiper");
  if (heroSwiperEl) {
    const heroSlideCount = heroSwiperEl.querySelectorAll(".swiper-slide").length;
    const heroHasMultiple = heroSlideCount > 1;

    const heroSliderSection = heroSwiperEl.closest(".hero-slider");
    const heroControls = heroSwiperEl.querySelector(".hero-slider-controls");

    if (!heroHasMultiple) {
      heroSliderSection?.classList.add("hero-slider--single");
      heroControls?.remove();
    } else {
      heroSliderSection?.classList.remove("hero-slider--single");
      heroSwiperEl.querySelectorAll(".hero-actions .btn").forEach(function (btn) {
        btn.classList.add("swiper-no-swiping");
      });
    }

    new Swiper(heroSwiperEl, {
      loop: false,
      effect: "fade",
      fadeEffect: { crossFade: true },
      speed: 650,
      noSwiping: true,
      noSwipingClass: "swiper-no-swiping",
      touchEventsTarget: "container",
      autoplay: heroHasMultiple
        ? { delay: 7000, disableOnInteraction: false, pauseOnMouseEnter: true }
        : false,
      navigation: heroHasMultiple
        ? {
            nextEl: ".hero-slider-btn--next",
            prevEl: ".hero-slider-btn--prev",
          }
        : false,
      a11y: {
        enabled: true,
        prevSlideMessage: "Poprzedni slajd",
        nextSlideMessage: "Następny slajd",
      },
      on: {
        reachEnd(swiper) {
          if (!heroHasMultiple || !swiper.autoplay?.running) {
            return;
          }

          setTimeout(() => {
            swiper.slideTo(0, swiper.params.speed);
          }, swiper.params.autoplay.delay);
        },
      },
    });
  }

  document.querySelectorAll(".hero-slide-content").forEach(function (contentEl) {
    contentEl.addEventListener(
      "wheel",
      function (event) {
        const overflowY = window.getComputedStyle(contentEl).overflowY;
        if (overflowY !== "auto" && overflowY !== "scroll") {
          return;
        }

        const hasOverflow = contentEl.scrollHeight > contentEl.clientHeight + 1;
        const atTop = contentEl.scrollTop <= 0;
        const atBottom =
          contentEl.scrollTop + contentEl.clientHeight >= contentEl.scrollHeight - 1;
        const scrollingUp = event.deltaY < 0;
        const scrollingDown = event.deltaY > 0;

        if (!hasOverflow || (scrollingUp && atTop) || (scrollingDown && atBottom)) {
          window.scrollBy(0, event.deltaY);
        }
      },
      { passive: true }
    );
  });

  const pillarsSwiperEl = document.querySelector(".pillars-swiper");
  if (pillarsSwiperEl) {
    const pillarsSection = pillarsSwiperEl.closest(".pillars-slider-section");
    const pillarTabs = pillarsSection
      ? pillarsSection.querySelectorAll(".pillars-tab")
      : [];
    const pillarTrack = pillarsSection
      ? pillarsSection.querySelector(".pillars-tabs-track")
      : null;
    const pillarIndicator = pillarsSection
      ? pillarsSection.querySelector(".pillars-tabs-indicator")
      : null;
    const pillarSlideCount = pillarsSwiperEl.querySelectorAll(
      ".swiper-slide"
    ).length;
    const pillarsHasMultiple = pillarSlideCount > 1;

    const updatePillarIndicator = (activeTab) => {
      if (!pillarIndicator || !activeTab || !pillarTrack) return;
      const trackRect = pillarTrack.getBoundingClientRect();
      const tabRect = activeTab.getBoundingClientRect();
      pillarIndicator.style.width = tabRect.width + "px";
      pillarIndicator.style.transform =
        "translateX(" + (tabRect.left - trackRect.left) + "px)";
    };

    const updatePillarTabs = (index) => {
      pillarTabs.forEach(function (tab, tabIndex) {
        const isActive = tabIndex === index;
        tab.classList.toggle("is-active", isActive);
        tab.setAttribute("aria-selected", isActive ? "true" : "false");
      });
      updatePillarIndicator(pillarTabs[index]);
    };

    const pillarsSwiper = new Swiper(pillarsSwiperEl, {
      effect: "fade",
      fadeEffect: { crossFade: true },
      speed: 550,
      loop: false,
      autoHeight: true,
      navigation: pillarsHasMultiple && pillarsSection
        ? {
            nextEl: pillarsSection.querySelector(".pillars-slider-btn--next"),
            prevEl: pillarsSection.querySelector(".pillars-slider-btn--prev"),
          }
        : false,
      a11y: {
        enabled: true,
        prevSlideMessage: "Poprzedni filar",
        nextSlideMessage: "Następny filar",
      },
      on: {
        init: function () {
          updatePillarTabs(this.activeIndex);
        },
        slideChange: function () {
          updatePillarTabs(this.activeIndex);
        },
      },
    });

    pillarTabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        const index = parseInt(tab.getAttribute("data-index"), 10);
        if (!isNaN(index)) {
          pillarsSwiper.slideTo(index);
        }
      });
    });

    window.addEventListener("resize", function () {
      const activeTab = pillarsSection
        ? pillarsSection.querySelector(".pillars-tab.is-active")
        : null;
      updatePillarIndicator(activeTab);
    });
  }

  const newsSwiperEl = document.querySelector(".news-swiper");
  if (newsSwiperEl) {
    new Swiper(newsSwiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      breakpoints: {
        769: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    });
  }

  document.querySelectorAll(".training-stations-section").forEach((trainingStationsSection) => {
    const trainingStationsSwiperEl = trainingStationsSection.querySelector(".training-stations-swiper");
    if (!trainingStationsSwiperEl) {
      return;
    }

    const getTrainingStationsSpaceBetween = (swiper) => {
      if (swiper && typeof swiper.params.spaceBetween === "number") {
        return swiper.params.spaceBetween;
      }

      return window.innerWidth >= 769 ? 36 : 16;
    };

    const getTrainingStationsOffsetAfter = (swiper) => {
      const slides = swiper?.slides?.length
        ? swiper.slides
        : trainingStationsSwiperEl.querySelectorAll(".training-stations-slide");

      if (!slides.length) return 0;

      const slideWidth =
        swiper?.slides?.[0]?.swiperSlideSize ??
        slides[0].getBoundingClientRect().width;
      const containerWidth = swiper?.width ?? trainingStationsSwiperEl.clientWidth;
      const spaceBetween = getTrainingStationsSpaceBetween(swiper);
      const slideCount = slides.length;
      const totalSlidesWidth =
        slideCount * slideWidth + (slideCount - 1) * spaceBetween;
      const lastSlideTranslate = (slideCount - 1) * (slideWidth + spaceBetween);
      const naturalMaxTranslate = Math.max(0, totalSlidesWidth - containerWidth);

      return Math.max(0, Math.round(lastSlideTranslate - naturalMaxTranslate));
    };

    const syncTrainingStationsActive = (swiper) => {
      swiper.slides.forEach((slide, index) => {
        slide.classList.toggle("is-station-active", index === swiper.activeIndex);
      });
    };

    const updateTrainingStationsOffset = (swiper) => {
      swiper.params.slidesOffsetAfter = getTrainingStationsOffsetAfter(swiper);
      swiper.update();
      syncTrainingStationsActive(swiper);
    };

    const trainingStationsSwiper = new Swiper(trainingStationsSwiperEl, {
      slidesPerView: "auto",
      spaceBetween: 16,
      grabCursor: true,
      watchSlidesProgress: true,
      speed: 450,
      threshold: 8,
      preventClicks: false,
      preventClicksPropagation: false,
      navigation: {
        nextEl: trainingStationsSection.querySelector(".training-stations-btn--next"),
        prevEl: trainingStationsSection.querySelector(".training-stations-btn--prev"),
      },
      breakpoints: {
        769: {
          spaceBetween: 36,
        },
      },
      on: {
        init: updateTrainingStationsOffset,
        resize: updateTrainingStationsOffset,
        breakpoint: updateTrainingStationsOffset,
        slideChangeTransitionStart: syncTrainingStationsActive,
        slideChangeTransitionEnd: syncTrainingStationsActive,
        click(swiper, event) {
          if (!swiper.allowClick || swiper.slides.length <= 1) {
            return;
          }

          const slideEl = event.target.closest(".training-stations-slide");
          const mediaEl = event.target.closest(".training-stations-media");

          if (!slideEl || !mediaEl) {
            return;
          }

          const slideIndex = Array.prototype.indexOf.call(swiper.slides, slideEl);
          if (slideIndex < 0) {
            return;
          }

          const cardLink = slideEl.querySelector("a.training-stations-card");
          const isActive = slideIndex === swiper.activeIndex;

          if (!isActive) {
            event.preventDefault();
            swiper.slideTo(slideIndex);
            return;
          }

          if (slideIndex < swiper.slides.length - 1) {
            event.preventDefault();
            swiper.slideNext();
          } else if (cardLink) {
            return;
          }
        },
      },
    });

    trainingStationsSection.classList.toggle(
      "training-stations-section--interactive",
      trainingStationsSwiper.slides.length > 1,
    );
  });

  const careerBenefitsSection = document.querySelector(".career-benefits-section");
  const careerBenefitsSwiperEl = careerBenefitsSection
    ? careerBenefitsSection.querySelector(".career-benefits-swiper")
    : null;

  if (careerBenefitsSwiperEl) {
    const getCareerBenefitsSpaceBetween = (swiper) => {
      if (swiper && typeof swiper.params.spaceBetween === "number") {
        return swiper.params.spaceBetween;
      }

      return window.innerWidth >= 769 ? 32 : 24;
    };

    const getCareerBenefitsOffsetAfter = (swiper) => {
      const slides = swiper?.slides?.length
        ? swiper.slides
        : careerBenefitsSwiperEl.querySelectorAll(".career-benefits-slide");

      if (!slides.length) return 0;

      const slideWidth =
        swiper?.slides?.[0]?.swiperSlideSize ??
        slides[0].getBoundingClientRect().width;
      const containerWidth = swiper?.width ?? careerBenefitsSwiperEl.clientWidth;
      const spaceBetween = getCareerBenefitsSpaceBetween(swiper);
      const slideCount = slides.length;
      const totalSlidesWidth =
        slideCount * slideWidth + (slideCount - 1) * spaceBetween;
      const lastSlideTranslate = (slideCount - 1) * (slideWidth + spaceBetween);
      const naturalMaxTranslate = Math.max(0, totalSlidesWidth - containerWidth);

      return Math.max(0, Math.round(lastSlideTranslate - naturalMaxTranslate));
    };

    const syncCareerBenefitsActive = (swiper) => {
      swiper.slides.forEach((slide, index) => {
        slide.classList.toggle("is-benefit-active", index === swiper.activeIndex);
      });
    };

    const updateCareerBenefitsOffset = (swiper) => {
      swiper.params.slidesOffsetAfter = getCareerBenefitsOffsetAfter(swiper);
      swiper.update();
      syncCareerBenefitsActive(swiper);
    };

    new Swiper(careerBenefitsSwiperEl, {
      slidesPerView: "auto",
      spaceBetween: 24,
      grabCursor: true,
      watchSlidesProgress: true,
      speed: 450,
      threshold: 8,
      preventClicks: false,
      preventClicksPropagation: false,
      navigation: {
        nextEl: careerBenefitsSection.querySelector(".career-benefits-btn--next"),
        prevEl: careerBenefitsSection.querySelector(".career-benefits-btn--prev"),
      },
      breakpoints: {
        769: {
          spaceBetween: 32,
        },
      },
      on: {
        init: updateCareerBenefitsOffset,
        resize: updateCareerBenefitsOffset,
        breakpoint: updateCareerBenefitsOffset,
        slideChangeTransitionStart: syncCareerBenefitsActive,
        slideChangeTransitionEnd: syncCareerBenefitsActive,
      },
    });
  }

  document.querySelectorAll(".trainers-section .trainers-swiper").forEach((trainersSwiperEl) => {
    const trainersSection = trainersSwiperEl.closest(".trainers-section");
    if (!trainersSection) {
      return;
    }

    const slideCount = trainersSwiperEl.querySelectorAll(".trainers-grid-item").length;
    const desktopQuery = window.matchMedia("(min-width: 769px)");
    let trainersSwiper = null;

    const destroyTrainersSwiper = () => {
      if (!trainersSwiper) {
        return;
      }

      trainersSwiper.destroy(true, true);
      trainersSwiper = null;
      trainersSection.classList.remove("trainers-section--slider");
    };

    const initTrainersSwiper = () => {
      destroyTrainersSwiper();

      if (desktopQuery.matches || slideCount <= 1) {
        return;
      }

      trainersSection.classList.add("trainers-section--slider");

      trainersSwiper = new Swiper(trainersSwiperEl, {
        slidesPerView: 1,
        spaceBetween: 16,
        grabCursor: true,
        speed: 450,
        threshold: 8,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: trainersSection.querySelector(".trainers-btn--next"),
          prevEl: trainersSection.querySelector(".trainers-btn--prev"),
        },
        on: {
          init(swiper) {
            swiper.slideTo(0, 0);
            swiper.update();
          },
        },
      });
    };

    initTrainersSwiper();
    desktopQuery.addEventListener("change", initTrainersSwiper);
    window.addEventListener("resize", initTrainersSwiper);
  });

  document.querySelectorAll(".employee-testimonials-section .employee-testimonials-swiper").forEach((employeeTestimonialsSwiperEl) => {
    const employeeTestimonialsSection = employeeTestimonialsSwiperEl.closest(".employee-testimonials-section");
    if (!employeeTestimonialsSection) {
      return;
    }

    const slideCount = employeeTestimonialsSwiperEl.querySelectorAll(".employee-testimonials-grid-item").length;
    const desktopQuery = window.matchMedia("(min-width: 769px)");
    let employeeTestimonialsSwiper = null;

    const destroyEmployeeTestimonialsSwiper = () => {
      if (!employeeTestimonialsSwiper) {
        return;
      }

      employeeTestimonialsSwiper.destroy(true, true);
      employeeTestimonialsSwiper = null;
      employeeTestimonialsSection.classList.remove("employee-testimonials-section--slider");
    };

    const initEmployeeTestimonialsSwiper = () => {
      destroyEmployeeTestimonialsSwiper();

      if (desktopQuery.matches || slideCount <= 1) {
        return;
      }

      employeeTestimonialsSection.classList.add("employee-testimonials-section--slider");

      employeeTestimonialsSwiper = new Swiper(employeeTestimonialsSwiperEl, {
        slidesPerView: 1,
        spaceBetween: 16,
        grabCursor: true,
        speed: 450,
        threshold: 8,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: employeeTestimonialsSection.querySelector(".employee-testimonials-btn--next"),
          prevEl: employeeTestimonialsSection.querySelector(".employee-testimonials-btn--prev"),
        },
        on: {
          init(swiper) {
            swiper.slideTo(0, 0);
            swiper.update();
          },
        },
      });
    };

    initEmployeeTestimonialsSwiper();
    desktopQuery.addEventListener("change", initEmployeeTestimonialsSwiper);
    window.addEventListener("resize", initEmployeeTestimonialsSwiper);
  });

  if (document.querySelector(".mySwiper")) {
    new Swiper(".mySwiper", {
  loop: true,
  effect: "fade",
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
  }
}

(function () {
  document.querySelectorAll(".company-values-section").forEach(function (section) {
    const tabs = section.querySelectorAll(".company-values-item");
    const panels = section.querySelectorAll(".company-values-panel-content");

    if (!tabs.length || !panels.length) return;

    const activateCompanyValue = function (index) {
      tabs.forEach(function (tab, tabIndex) {
        const isActive = tabIndex === index;
        tab.classList.toggle("is-active", isActive);
        tab.setAttribute("aria-selected", isActive ? "true" : "false");
      });

      panels.forEach(function (panel, panelIndex) {
        const isActive = panelIndex === index;
        panel.classList.toggle("is-active", isActive);
        if (isActive) {
          panel.removeAttribute("hidden");
        } else {
          panel.setAttribute("hidden", "");
        }
      });
    };

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        const index = parseInt(tab.getAttribute("data-index"), 10);
        if (isNaN(index)) return;
        activateCompanyValue(index);
        tab.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "nearest",
        });
      });
    });
  });
})();

(function () {
  const scrollRoot = document.querySelector("[data-b2b-support-scroll]");
  if (!scrollRoot) return;

  const stickyPanel = scrollRoot.querySelector(".b2b-support-sticky");
  const steps = scrollRoot.querySelectorAll(".b2b-support-step");
  const images = scrollRoot.querySelectorAll(".b2b-support-media-img");
  const itemCount = steps.length;

  if (!itemCount || !stickyPanel) return;

  const desktopQuery = window.matchMedia("(min-width: 1025px)");
  const reduceMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

  function getStepOpacity(stepIndex, activeIndex) {
    const distance = Math.abs(stepIndex - activeIndex);
    if (distance === 0) return 1;
    if (distance === 1) return 0.5;
    if (distance === 2) return 0.3;
    return 0.1;
  }

  const stepsContainer = scrollRoot.querySelector(".b2b-support-steps");

  function scrollActiveStepIntoView(index) {
    if (!desktopQuery.matches || !stepsContainer) return;

    const activeStep = steps[index];
    if (!activeStep) return;

    const containerRect = stepsContainer.getBoundingClientRect();
    const stepRect = activeStep.getBoundingClientRect();

    if (stepRect.top < containerRect.top - 1) {
      stepsContainer.scrollTop -= containerRect.top - stepRect.top;
    } else if (stepRect.bottom > containerRect.bottom + 1) {
      stepsContainer.scrollTop += stepRect.bottom - containerRect.bottom;
    }
  }

  function setActiveIndex(index) {
    steps.forEach(function (step, stepIndex) {
      const isActive = stepIndex === index;
      step.classList.toggle("is-active", isActive);
      if (desktopQuery.matches && !reduceMotionQuery.matches) {
        step.style.opacity = String(getStepOpacity(stepIndex, index));
      } else {
        step.style.opacity = "";
      }
    });

    images.forEach(function (image, imageIndex) {
      image.classList.toggle("is-active", imageIndex === index);
    });

    scrollActiveStepIntoView(index);
  }

  function updateSupportScroll() {
    if (!desktopQuery.matches || reduceMotionQuery.matches) {
      setActiveIndex(0);
      return;
    }

    const scrollHeight = scrollRoot.offsetHeight - stickyPanel.offsetHeight;
    const scrolled = Math.min(
      Math.max(-scrollRoot.getBoundingClientRect().top, 0),
      scrollHeight
    );
    const progress = scrollHeight > 0 ? scrolled / scrollHeight : 0;
    const activeIndex = Math.min(
      Math.floor(progress * itemCount),
      itemCount - 1
    );

    setActiveIndex(activeIndex);
  }

  function getSupportWheelDelta(event) {
    let delta = event.deltaY;

    if (event.deltaMode === 1) {
      delta *= 16;
    } else if (event.deltaMode === 2) {
      delta *= window.innerHeight;
    }

    return delta * 3;
  }

  if (stepsContainer) {
    stepsContainer.addEventListener(
      "wheel",
      function (event) {
        if (!desktopQuery.matches || reduceMotionQuery.matches) {
          return;
        }

        event.preventDefault();
        window.scrollBy(0, getSupportWheelDelta(event));
      },
      { passive: false }
    );
  }

  window.addEventListener("scroll", updateSupportScroll, { passive: true });
  window.addEventListener("resize", updateSupportScroll);
  desktopQuery.addEventListener("change", updateSupportScroll);
  reduceMotionQuery.addEventListener("change", updateSupportScroll);
  updateSupportScroll();
})();

(function () {
  const downloadsRoot = document.querySelector("[data-downloads-list]");
  if (!downloadsRoot) return;

  const brandFilters = downloadsRoot.querySelectorAll("[data-brand-filter]");
  const typeFilters = downloadsRoot.querySelectorAll("[data-type-filter]");
  const rows = downloadsRoot.querySelectorAll(".doc-row");
  const countEl = downloadsRoot.querySelector("[data-downloads-count]");
  const emptyEl = downloadsRoot.querySelector("[data-downloads-empty]");
  const scrollTarget = downloadsRoot.querySelector(".downloads-filters-panel") || downloadsRoot;

  let activeBrand = "all";
  let activeType = "all";

  function getDownloadsScrollPadding() {
    return 40;
  }

  function scrollToDownloadsSection(instant) {
    const reducedMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    const headerOffset =
      parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--header-height")) || 75;
    const scrollPadding = getDownloadsScrollPadding();
    const scrollBehavior = instant || reducedMotionQuery.matches ? "auto" : "smooth";

    function performScroll() {
      const scrollTop =
        scrollTarget.getBoundingClientRect().top + window.scrollY - headerOffset - scrollPadding;

      window.scrollTo({
        top: Math.max(0, scrollTop),
        behavior: scrollBehavior,
      });
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(performScroll);
    });
  }

  function getDownloadTypeFromHash(hash) {
    if (!hash || hash === "#") {
      return null;
    }

    const raw = decodeURIComponent(hash.replace(/^#/, ""));

    if (raw === "dokumenty-do-pobrania") {
      return null;
    }

    if (raw.startsWith("pobrania-")) {
      return raw.slice("pobrania-".length);
    }

    if (raw.startsWith("downloads-")) {
      return raw.slice("downloads-".length);
    }

    return null;
  }

  function findDownloadBrandFilter(brandId) {
    if (!brandId || brandId === "all") {
      return "all";
    }

    const chip = Array.from(brandFilters).find(function (item) {
      return item.getAttribute("data-brand-filter") === brandId;
    });

    return chip ? brandId : "all";
  }

  function findDownloadTypeFilter(typeId) {
    if (!typeId || typeId === "all") {
      return "all";
    }

    const normalized = typeId.toLowerCase();
    const chip = Array.from(typeFilters).find(function (item) {
      return (item.getAttribute("data-type-filter") || "").toLowerCase() === normalized;
    });

    return chip ? chip.getAttribute("data-type-filter") || normalized : "all";
  }

  function buildDownloadsUrl(brand, type) {
    const params = new URLSearchParams(window.location.search);

    if (brand === "all") {
      params.delete("downloadBrand");
    } else {
      params.set("downloadBrand", brand);
    }

    if (type === "all") {
      params.delete("downloadType");
    } else {
      params.set("downloadType", type);
    }

    const queryString = params.toString();

    return window.location.pathname + (queryString ? "?" + queryString : "");
  }

  function readDownloadsFiltersFromUrl() {
    const params = new URLSearchParams(window.location.search);
    let brand = findDownloadBrandFilter(params.get("downloadBrand") || "all");
    let type = findDownloadTypeFilter(params.get("downloadType") || "all");

    if (type === "all") {
      type = findDownloadTypeFilter(getDownloadTypeFromHash(window.location.hash) || "all");
    }

    return { brand: brand, type: type };
  }

  function updateDownloadsUrl(usePushState) {
    if (!window.history) {
      return;
    }

    const nextUrl = buildDownloadsUrl(activeBrand, activeType);
    const currentUrl = window.location.pathname + window.location.search + window.location.hash;

    if (currentUrl === nextUrl) {
      return;
    }

    if (usePushState && window.history.pushState) {
      window.history.pushState({ downloadsFilters: true }, "", nextUrl);
    } else if (window.history.replaceState) {
      window.history.replaceState({ downloadsFilters: true }, "", nextUrl);
    }
  }

  function setActiveChip(chips, attr, value) {
    chips.forEach(function (chip) {
      const isActive = chip.getAttribute(attr) === value;
      chip.classList.toggle("is-active", isActive);
      chip.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  }

  function updateDownloadsList() {
    let visibleCount = 0;

    rows.forEach(function (row) {
      const brandMatch =
        activeBrand === "all" || row.getAttribute("data-brand-id") === activeBrand;
      const typeMatch =
        activeType === "all" || row.getAttribute("data-type-id") === activeType;
      const isVisible = brandMatch && typeMatch;

      row.classList.toggle("is-hidden", !isVisible);
      if (isVisible) visibleCount += 1;
    });

    if (countEl) countEl.textContent = String(visibleCount);
    if (emptyEl) emptyEl.hidden = visibleCount > 0;
  }

  function applyDownloadsFilters(brand, type, options) {
    const opts = options || {};
    const nextBrand = findDownloadBrandFilter(brand || "all");
    const nextType = findDownloadTypeFilter(type || "all");

    activeBrand = nextBrand;
    activeType = nextType;
    setActiveChip(brandFilters, "data-brand-filter", activeBrand);
    setActiveChip(typeFilters, "data-type-filter", activeType);
    updateDownloadsList();

    if (!opts.skipUrlUpdate) {
      updateDownloadsUrl(opts.usePushState === true);
    }

    if (opts.scroll) {
      scrollToDownloadsSection(opts.instantScroll === true);
    }

    return true;
  }

  brandFilters.forEach(function (chip) {
    chip.addEventListener("click", function () {
      applyDownloadsFilters(chip.getAttribute("data-brand-filter") || "all", activeType, {
        usePushState: true,
        scroll: true,
      });
    });
  });

  typeFilters.forEach(function (chip) {
    chip.addEventListener("click", function () {
      applyDownloadsFilters(activeBrand, chip.getAttribute("data-type-filter") || "all", {
        usePushState: true,
        scroll: true,
      });
    });
  });

  if (!window.__downloadsHistoryListener) {
    window.__downloadsHistoryListener = true;
    window.addEventListener("popstate", function () {
      const filters = readDownloadsFiltersFromUrl();
      applyDownloadsFilters(filters.brand, filters.type, { skipUrlUpdate: true });
    });
  }

  if (!window.__downloadsHashListener) {
    window.__downloadsHashListener = true;
    window.addEventListener("hashchange", function () {
      const hashType = getDownloadTypeFromHash(window.location.hash);
      if (!hashType) {
        return;
      }

      applyDownloadsFilters(activeBrand, hashType, { usePushState: false, scroll: true });
    });
  }

  const initialFilters = readDownloadsFiltersFromUrl();
  const shouldScrollOnInit =
    initialFilters.brand !== "all" ||
    initialFilters.type !== "all" ||
    Boolean(getDownloadTypeFromHash(window.location.hash));

  applyDownloadsFilters(initialFilters.brand, initialFilters.type, {
    usePushState: false,
    scroll: shouldScrollOnInit,
    instantScroll: true,
  });
})();

(function () {
  const trainingsRoot = document.querySelector("[data-trainings-list]");
  if (!trainingsRoot) return;

  const brandFilters = trainingsRoot.querySelectorAll("[data-brand-filter]");
  const modeFilters = trainingsRoot.querySelectorAll("[data-mode-filter]");
  const items = trainingsRoot.querySelectorAll("[data-training-item]");
  const countEl = trainingsRoot.querySelector("[data-trainings-count]");
  const emptyEl = trainingsRoot.querySelector("[data-trainings-empty]");
  const signupModal = document.getElementById("training-signup-modal");
  const signupIdField = signupModal
    ? signupModal.querySelector("[data-training-signup-id]")
    : null;
  const signupTitleEl = signupModal
    ? signupModal.querySelector("#training-signup-modal-label")
    : null;
  const defaultModalTitle = signupTitleEl ? signupTitleEl.textContent.trim() : "Zapisz się";

  let activeBrand = "all";
  let activeMode = "all";

  function findTrainingBrandFilter(brandId) {
    if (!brandId || brandId === "all") {
      return "all";
    }

    const chip = Array.from(brandFilters).find(function (item) {
      return item.getAttribute("data-brand-filter") === brandId;
    });

    return chip ? brandId : "all";
  }

  function findTrainingModeFilter(modeId) {
    if (!modeId || modeId === "all") {
      return "all";
    }

    const chip = Array.from(modeFilters).find(function (item) {
      return item.getAttribute("data-mode-filter") === modeId;
    });

    return chip ? modeId : "all";
  }

  function buildTrainingsUrl(brand, mode) {
    const params = new URLSearchParams(window.location.search);

    if (brand === "all") {
      params.delete("trainingBrand");
    } else {
      params.set("trainingBrand", brand);
    }

    if (mode === "all") {
      params.delete("trainingMode");
    } else {
      params.set("trainingMode", mode);
    }

    const queryString = params.toString();

    return window.location.pathname + (queryString ? "?" + queryString : "");
  }

  function readTrainingsFiltersFromUrl() {
    const params = new URLSearchParams(window.location.search);

    return {
      brand: findTrainingBrandFilter(params.get("trainingBrand") || "all"),
      mode: findTrainingModeFilter(params.get("trainingMode") || "all"),
    };
  }

  function updateTrainingsUrl(usePushState) {
    if (!window.history) {
      return;
    }

    const nextUrl = buildTrainingsUrl(activeBrand, activeMode);
    const currentUrl = window.location.pathname + window.location.search + window.location.hash;

    if (currentUrl === nextUrl) {
      return;
    }

    if (usePushState && window.history.pushState) {
      window.history.pushState({ trainingsFilters: true }, "", nextUrl);
    } else if (window.history.replaceState) {
      window.history.replaceState({ trainingsFilters: true }, "", nextUrl);
    }
  }

  function setActiveChip(chips, attr, value) {
    chips.forEach(function (chip) {
      const isActive = chip.getAttribute(attr) === value;
      chip.classList.toggle("is-active", isActive);
      chip.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  }

  function updateTrainingsList() {
    let visibleCount = 0;

    items.forEach(function (item) {
      const brandMatch =
        activeBrand === "all" || item.getAttribute("data-brand-id") === activeBrand;
      const modeMatch =
        activeMode === "all" || item.getAttribute("data-mode-id") === activeMode;
      const isVisible = brandMatch && modeMatch;

      item.classList.toggle("is-hidden", !isVisible);
      if (isVisible) visibleCount += 1;
    });

    if (countEl) countEl.textContent = String(visibleCount);
    if (emptyEl) emptyEl.hidden = visibleCount > 0;
  }

  function applyTrainingsFilters(brand, mode, options) {
    const opts = options || {};

    activeBrand = findTrainingBrandFilter(brand || "all");
    activeMode = findTrainingModeFilter(mode || "all");
    setActiveChip(brandFilters, "data-brand-filter", activeBrand);
    setActiveChip(modeFilters, "data-mode-filter", activeMode);
    updateTrainingsList();

    if (!opts.skipUrlUpdate) {
      updateTrainingsUrl(opts.usePushState === true);
    }
  }

  brandFilters.forEach(function (chip) {
    chip.addEventListener("click", function () {
      applyTrainingsFilters(chip.getAttribute("data-brand-filter") || "all", activeMode, {
        usePushState: true,
      });
    });
  });

  modeFilters.forEach(function (chip) {
    chip.addEventListener("click", function () {
      applyTrainingsFilters(activeBrand, chip.getAttribute("data-mode-filter") || "all", {
        usePushState: true,
      });
    });
  });

  trainingsRoot.querySelectorAll("[data-training-id]").forEach(function (button) {
    button.addEventListener("click", function () {
      const trainingId = button.getAttribute("data-training-id") || "";
      const trainingTitle = button.getAttribute("data-training-title") || "";

      if (signupIdField) signupIdField.value = trainingId;
      if (signupTitleEl) {
        signupTitleEl.textContent = trainingTitle
          ? defaultModalTitle + " — " + trainingTitle
          : defaultModalTitle;
      }
    });
  });

  if (!window.__trainingsHistoryListener) {
    window.__trainingsHistoryListener = true;
    window.addEventListener("popstate", function () {
      const filters = readTrainingsFiltersFromUrl();
      applyTrainingsFilters(filters.brand, filters.mode, { skipUrlUpdate: true });
    });
  }

  const initialFilters = readTrainingsFiltersFromUrl();
  applyTrainingsFilters(initialFilters.brand, initialFilters.mode, { usePushState: false });
})();

(function () {
  const knowledgeRoot = document.querySelector("[data-knowledge-list]");
  if (!knowledgeRoot) return;

  const pageInput = knowledgeRoot.querySelector("[data-knowledge-page-input]");

  if (pageInput) {
    const brandFilters = knowledgeRoot.querySelectorAll("[data-brand-filter]");
    const typeFilters = knowledgeRoot.querySelectorAll("[data-type-filter]");
    const prevBtn = knowledgeRoot.querySelector("[data-knowledge-page-prev]");
    const nextBtn = knowledgeRoot.querySelector("[data-knowledge-page-next]");
    const activeBrand = knowledgeRoot.getAttribute("data-knowledge-active-brand") || "all";
    const activeType = knowledgeRoot.getAttribute("data-knowledge-active-type") || "all";
    const currentPage = parseInt(knowledgeRoot.getAttribute("data-knowledge-current-page") || "1", 10);
    const totalPages = parseInt(knowledgeRoot.getAttribute("data-knowledge-total-pages") || "1", 10);
    const maxMessageTemplate = knowledgeRoot.getAttribute("data-knowledge-page-max-message") || "";
    const KNOWLEDGE_SCROLL_MODE_KEY = "knowledge-list-scroll-mode";

    function getKnowledgeHeaderHeight() {
      return (
        parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue("--header-height")
        ) || 80
      );
    }

    function isKnowledgeListInView() {
      const rect = knowledgeRoot.getBoundingClientRect();
      const headerHeight = getKnowledgeHeaderHeight();
      return rect.top <= headerHeight + 100 && rect.bottom > headerHeight + 50;
    }

    function scrollKnowledgeListIntoView(behavior) {
      const headerHeight = getKnowledgeHeaderHeight();
      const top =
        knowledgeRoot.getBoundingClientRect().top + window.scrollY - headerHeight;

      window.scrollTo({
        top: Math.max(0, top),
        behavior: behavior || "auto",
      });
    }

    function buildKnowledgeUrl(page, brand, type) {
      const params = new URLSearchParams(window.location.search);

      if (brand === "all") {
        params.delete("blogBrand");
      } else {
        params.set("blogBrand", brand);
      }

      if (type === "all") {
        params.delete("blogType");
      } else {
        params.set("blogType", type);
      }

      if (page <= 1) {
        params.delete("blogPage");
      } else {
        params.set("blogPage", String(page));
      }

      const queryString = params.toString();
      return (
        window.location.pathname +
        (queryString ? "?" + queryString : "") +
        "#knowledge-list"
      );
    }

    function navigateKnowledgeList(page, brand, type) {
      let targetPage = parseInt(String(page), 10);

      if (isNaN(targetPage) || targetPage < 1) {
        targetPage = 1;
      }

      if (targetPage > totalPages) {
        if (maxMessageTemplate) {
          window.alert(maxMessageTemplate.replace("%max%", String(totalPages)));
        }
        targetPage = totalPages;
      }

      if (targetPage === currentPage && brand === activeBrand && type === activeType) {
        pageInput.value = "";
        return;
      }

      sessionStorage.setItem(
        KNOWLEDGE_SCROLL_MODE_KEY,
        isKnowledgeListInView() ? "instant" : "smooth"
      );
      window.location.assign(buildKnowledgeUrl(targetPage, brand, type));
    }

    brandFilters.forEach(function (chip) {
      chip.addEventListener("click", function () {
        navigateKnowledgeList(1, chip.getAttribute("data-brand-filter") || "all", activeType);
      });
    });

    typeFilters.forEach(function (chip) {
      chip.addEventListener("click", function () {
        navigateKnowledgeList(1, activeBrand, chip.getAttribute("data-type-filter") || "all");
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        if (currentPage > 1) {
          navigateKnowledgeList(currentPage - 1, activeBrand, activeType);
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        if (currentPage < totalPages) {
          navigateKnowledgeList(currentPage + 1, activeBrand, activeType);
        }
      });
    }

    function handleKnowledgePageInput() {
      const rawValue = pageInput.value.trim();

      if (!rawValue) {
        pageInput.value = "";
        return;
      }

      navigateKnowledgeList(rawValue, activeBrand, activeType);
    }

    pageInput.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        event.preventDefault();
        handleKnowledgePageInput();
      }
    });

    pageInput.addEventListener("change", handleKnowledgePageInput);

    if (
      window.location.hash === "#knowledge-list" ||
      new URLSearchParams(window.location.search).has("blogPage")
    ) {
      const scrollMode = sessionStorage.getItem(KNOWLEDGE_SCROLL_MODE_KEY);
      sessionStorage.removeItem(KNOWLEDGE_SCROLL_MODE_KEY);

      if (scrollMode !== "instant") {
        scrollKnowledgeListIntoView(scrollMode === "smooth" ? "smooth" : "auto");
      }
    }

    return;
  }

  const brandFilters = knowledgeRoot.querySelectorAll("[data-brand-filter]");
  const typeFilters = knowledgeRoot.querySelectorAll("[data-type-filter]");
  const items = knowledgeRoot.querySelectorAll("[data-knowledge-item]");
  const countEl = knowledgeRoot.querySelector("[data-knowledge-count]");
  const emptyEl = knowledgeRoot.querySelector("[data-knowledge-empty]");
  const paginationNav = knowledgeRoot.querySelector("[data-knowledge-pagination]");
  const pageList = knowledgeRoot.querySelector("[data-knowledge-page-list]");
  const prevBtn = knowledgeRoot.querySelector("[data-knowledge-page-prev]");
  const nextBtn = knowledgeRoot.querySelector("[data-knowledge-page-next]");
  const perPage = parseInt(knowledgeRoot.getAttribute("data-knowledge-per-page") || "9", 10);

  let activeBrand = "all";
  let activeType = "all";
  let currentPage = 1;

  function setActiveChip(chips, attr, value) {
    chips.forEach(function (chip) {
      const isActive = chip.getAttribute(attr) === value;
      chip.classList.toggle("is-active", isActive);
      chip.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  }

  function getFilteredItems() {
    return Array.prototype.filter.call(items, function (item) {
      const brandMatch =
        activeBrand === "all" || item.getAttribute("data-brand-id") === activeBrand;
      const typeMatch =
        activeType === "all" || item.getAttribute("data-type-id") === activeType;
      return brandMatch && typeMatch;
    });
  }

  function renderPagination(totalPages) {
    if (!pageList || !paginationNav) return;

    pageList.innerHTML = "";

    if (totalPages <= 1) {
      paginationNav.hidden = true;
      return;
    }

    paginationNav.hidden = false;

    for (let page = 1; page <= totalPages; page += 1) {
      const listItem = document.createElement("li");
      const button = document.createElement("button");
      button.type = "button";
      button.className = "knowledge-pagination-page";
      button.textContent = String(page);
      button.setAttribute("data-knowledge-page", String(page));

      if (page === currentPage) {
        button.classList.add("is-active");
        button.setAttribute("aria-current", "page");
      }

      button.addEventListener("click", function () {
        currentPage = page;
        updateKnowledgeList(false);
      });

      listItem.appendChild(button);
      pageList.appendChild(listItem);
    }
  }

  function updateKnowledgeList(resetPage) {
    if (resetPage) currentPage = 1;

    const filteredItems = getFilteredItems();
    const totalPages = Math.max(1, Math.ceil(filteredItems.length / perPage));

    if (currentPage > totalPages) currentPage = totalPages;

    items.forEach(function (item) {
      item.classList.add("is-hidden");
      item.classList.remove("is-page-hidden");
    });

    filteredItems.forEach(function (item, index) {
      item.classList.remove("is-hidden");

      const pageIndex = Math.floor(index / perPage) + 1;
      if (pageIndex !== currentPage) {
        item.classList.add("is-page-hidden");
      }
    });

    if (countEl) countEl.textContent = String(filteredItems.length);
    if (emptyEl) emptyEl.hidden = filteredItems.length > 0;

    renderPagination(totalPages);

    if (prevBtn) prevBtn.disabled = currentPage <= 1 || totalPages <= 1;
    if (nextBtn) nextBtn.disabled = currentPage >= totalPages || totalPages <= 1;
  }

  brandFilters.forEach(function (chip) {
    chip.addEventListener("click", function () {
      activeBrand = chip.getAttribute("data-brand-filter") || "all";
      setActiveChip(brandFilters, "data-brand-filter", activeBrand);
      updateKnowledgeList(true);
    });
  });

  typeFilters.forEach(function (chip) {
    chip.addEventListener("click", function () {
      activeType = chip.getAttribute("data-type-filter") || "all";
      setActiveChip(typeFilters, "data-type-filter", activeType);
      updateKnowledgeList(true);
    });
  });

  if (prevBtn) {
    prevBtn.addEventListener("click", function () {
      if (currentPage > 1) {
        currentPage -= 1;
        updateKnowledgeList(false);
        knowledgeRoot.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener("click", function () {
      const filteredItems = getFilteredItems();
      const totalPages = Math.max(1, Math.ceil(filteredItems.length / perPage));

      if (currentPage < totalPages) {
        currentPage += 1;
        updateKnowledgeList(false);
        knowledgeRoot.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  }

  updateKnowledgeList(true);
})();

(function () {
  function syncSearchFormType(type) {
    const form = document.querySelector(".search-section-form");

    if (!form) {
      return;
    }

    let hiddenInput = form.querySelector("[data-search-section-type]");

    if (type === "all") {
      if (hiddenInput) {
        hiddenInput.remove();
      }

      return;
    }

    if (!hiddenInput) {
      hiddenInput = document.createElement("input");
      hiddenInput.type = "hidden";
      hiddenInput.name = "type";
      hiddenInput.dataset.searchSectionType = "";
      form.appendChild(hiddenInput);
    }

    hiddenInput.value = type;
  }

  function updateSearchUrlFilter(type) {
    const params = new URLSearchParams(window.location.search);

    if (type === "all") {
      params.delete("type");
    } else {
      params.set("type", type);
    }

    const queryString = params.toString();
    const nextUrl = window.location.pathname + (queryString ? "?" + queryString : "");

    window.history.replaceState(null, "", nextUrl);
    syncSearchFormType(type);
  }

  document.querySelectorAll("[data-search-section]").forEach(function (section) {
    if (section.dataset.searchSectionInit === "true") {
      return;
    }

    section.dataset.searchSectionInit = "true";

    const paramName = section.dataset.queryParam || "q";
    const input = section.querySelector(".search-section-field");
    const form = section.querySelector(".search-section-form");

    if (!input || input.value) {
      const query = new URLSearchParams(window.location.search).get(paramName);

      if (query && input) {
        input.value = query;
      }
    } else {
      const query = new URLSearchParams(window.location.search).get(paramName);

      if (query) {
        input.value = query;
      }
    }

    if (form) {
      form.addEventListener("submit", function (e) {
        if (!input || !input.value.trim()) {
          e.preventDefault();
          input?.focus();
          return;
        }

        const activeTab = document.querySelector("[data-search-results-tab].is-active");
        const activeType = activeTab ? activeTab.dataset.filter || "all" : "all";

        syncSearchFormType(activeType);
      });
    }
  });

  document.querySelectorAll("[data-search-results]").forEach(function (section) {
    if (section.dataset.searchResultsInit === "true") {
      return;
    }

    section.dataset.searchResultsInit = "true";

    const queryLabel = section.querySelector("[data-search-results-query]");
    const countEl = section.querySelector("[data-search-results-count]");
    const listEl = section.querySelector("[data-search-results-list]");
    const emptyEl = section.querySelector("[data-search-results-empty]");
    const emptyTextEl = section.querySelector("[data-search-results-empty-text]");
    const items = section.querySelectorAll("[data-search-result-item]");
    const tabs = section.querySelectorAll("[data-search-results-tab]");
    const urlParams = new URLSearchParams(window.location.search);
    const query = (urlParams.get("q") || "").trim();
    const initialFilter = urlParams.get("type") || "";

    if (queryLabel) {
      queryLabel.textContent = query;
    }

    function updateCount(visibleCount) {
      if (!countEl) {
        return;
      }

      const template = countEl.dataset.countTemplate || "{count} przykładowych wyników";
      countEl.textContent = template.replace("{count}", String(visibleCount));
    }

    function updateEmptyState(visibleCount, activeFilter) {
      const showEmpty = visibleCount === 0;

      if (listEl) {
        listEl.hidden = showEmpty;
      }

      if (!emptyEl) {
        return;
      }

      emptyEl.hidden = !showEmpty;

      if (!showEmpty || !emptyTextEl) {
        return;
      }

      if (activeFilter !== "all") {
        emptyTextEl.textContent = emptyEl.dataset.emptyFiltered || "";
      } else {
        emptyTextEl.textContent = emptyEl.dataset.emptyQuery || "";
      }
    }

    function itemMatchesFilterType(itemType, filterType) {
      if (!filterType || filterType === "all") {
        return true;
      }

      if (itemType === filterType) {
        return true;
      }

      if (filterType === "documents" && itemType && itemType.indexOf("material-") === 0) {
        return true;
      }

      if (filterType === "knowledge" && itemType && itemType.indexOf("blog-") === 0) {
        return true;
      }

      return false;
    }

    function filterResults(type) {
      let visibleCount = 0;

      items.forEach(function (item) {
        const itemType = item.dataset.resultType || "";
        const isVisible = itemMatchesFilterType(itemType, type);
        item.hidden = !isVisible;

        if (isVisible) {
          visibleCount += 1;
        }
      });

      updateCount(visibleCount);
      updateEmptyState(visibleCount, type);
    }

    function activateTab(filterId, updateUrl) {
      const type = filterId || "all";
      let targetTab = null;

      tabs.forEach(function (tab) {
        const isActive = tab.dataset.filter === type;
        tab.classList.toggle("is-active", isActive);
        tab.setAttribute("aria-selected", isActive ? "true" : "false");

        if (isActive) {
          targetTab = tab;
        }
      });

      const activeType = targetTab ? type : "all";

      filterResults(activeType);

      if (updateUrl) {
        updateSearchUrlFilter(activeType);
      } else {
        syncSearchFormType(activeType);
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        const type = tab.dataset.filter || "all";
        const params = new URLSearchParams(window.location.search);

        if (type === "all") {
          params.delete("type");
        } else {
          params.set("type", type);
        }

        const nextUrl = window.location.pathname + (params.toString() ? "?" + params.toString() : "");

        if (nextUrl !== window.location.pathname + window.location.search) {
          window.location.assign(nextUrl);
        }
      });
    });

    if (initialFilter && section.querySelector('[data-search-results-tab][data-filter="' + initialFilter + '"]')) {
      activateTab(initialFilter, false);
    } else {
      activateTab("all", false);
    }
  });

  document.querySelectorAll(".search-modal-form").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      const input = form.querySelector(".search-modal-field");

      if (!input || !input.value.trim()) {
        e.preventDefault();
        input.focus();
      }
    });
  });
})();

(function initFaqAccordion() {
  document.querySelectorAll("[data-faq-accordion]").forEach(function (accordion) {
    const triggers = accordion.querySelectorAll(".faq-item-trigger");

    triggers.forEach(function (trigger) {
      trigger.addEventListener("click", function () {
        const panelId = trigger.getAttribute("aria-controls");
        const panel = panelId ? document.getElementById(panelId) : null;
        const isExpanded = trigger.getAttribute("aria-expanded") === "true";

        if (isExpanded) {
          trigger.setAttribute("aria-expanded", "false");
          if (panel) {
            panel.hidden = true;
          }
          return;
        }

        triggers.forEach(function (otherTrigger) {
          const otherPanelId = otherTrigger.getAttribute("aria-controls");
          const otherPanel = otherPanelId ? document.getElementById(otherPanelId) : null;
          otherTrigger.setAttribute("aria-expanded", "false");
          if (otherPanel) {
            otherPanel.hidden = true;
          }
        });

        trigger.setAttribute("aria-expanded", "true");
        if (panel) {
          panel.hidden = false;
        }
      });
    });
  });
})();

$(document).on("click", ".context-menu-opener", function () {
  let parentElement = $(this).parent().parent().parent();

  // Przełączanie klas dla różnych elementów
  parentElement
    .children(".context-menu, .menu-3,  .menu-4")
    .toggleClass("d-flex");
  parentElement.find(".menu-2").toggleClass("d-flex");
  $(this).toggleClass("opened");

  // Usunięcie klas, jeśli element nie ma klasy "opened"
  if (!$(this).hasClass("opened")) {
    parentElement
      .find(".menu-4, .menu-3, .menu-2, .context-menu")
      .removeClass("d-flex");
    parentElement.find(".opened").removeClass("opened");
  }
});
// $(document).on("mouseenter", ".menu-item", function () {
//   $(this).css("borderLeft", "1px solid white");
// });
// $(document).on("mouseleave", ".menu-item", function () {
//   $(this).css("borderLeft", "transparent");
// });
// $(document).ready(function () {
//   if ($(window).width() < 992) {
//     let halfNavHeight = $(".header__nav--lower").height();
//     $(".context-menu").css(
//       "height",
//       halfNavHeight - $(".header__nav--lower ul li").height()
//     );
//   }
// });

$(document).ready(function () {
  if ($(window).width() < 992) {
    let halfNavHeight = $(".header__nav--lower").height();
    let liHeight = $(".header__nav--lower ul li").height();

    $(".context-menu").each(function (index) {
      let newHeight = halfNavHeight - liHeight * (index + 1); // Dodanie 1 do indeksu, jeśli chcesz zacząć od 1 zamiast od 0
      $(this).css("height", 'auto');
      console.log(index);
    });
  }
});

$(".hamburger").click(function () {
  $(".header__container").toggleClass("header__container--active");
  $(".hamburger").toggleClass("hamburger--active");
  $(".search").removeClass("open");
});
$(document).click(function (event) {
  if (
    !$(event.target).is(
      ".hamburger, .hamburger span, .dropdown, .dropdown-toggle, .context-menu-opener"
    )
  ) {
    $(".header__container").removeClass("header__container--active");
    $(".hamburger").removeClass("hamburger--active");
  }
});
$(document).on("mouseenter", ".brand", function () {
  $(this)
    .children(".on-hover")
    .find("*")
    .css("transition-delay", 0 + "s");
});
const makeTime = function () {
  $(".brand").each(function () {
    let contentHeight = $(this).children(".brand__content").height();

    $(this)
      .children(".on-hover")
      .find("*")
      .css("transition-delay", contentHeight / 1000 + "s");
  });
};
$(document).on("mouseleave", ".brand", function () {
  makeTime();
});
$(document).ready(makeTime());
// $(".brand").click(function () {
//   if (!$(this).hasClass("active")) {
//     $(this).addClass("active");
//   } else {
//     $(this).removeClass("active");
//   }
// });
$(".accordion-button").click(function () {
  const allCollapsesElementsNotShow = document.querySelectorAll(
    ".accordion-collapse:not(.show)"
  );
  const allCollapsesElements = document.querySelectorAll(".accordion-collapse");
  if (
    allCollapsesElementsNotShow.length == allCollapsesElements.length &&
    $(this).hasClass("collapsed")
  ) {
    $(".accordions-hide").removeClass("d-none");

    $(".accordions-show").addClass("d-none");
  } else {
    $(".accordions-show").removeClass("d-none");

    $(".accordions-hide").addClass("d-none");
  }
});
$(".accordions-toggler").click(function () {
  const collapseElementList = document.querySelectorAll(".collapse.show");
  const allCollapsesElements = document.querySelectorAll(
    ".collapse:not(.show)"
  );
  const collapseList = [...collapseElementList].map(
    (collapseEl) => new bootstrap.Collapse(collapseEl)
  );
  // Jeżeli ilość elementów otwartych jest rowna wszystkim elementom wtedy
  if (collapseElementList.length == 0) {
    const collapseList = [...allCollapsesElements].map(
      (collapseEl) => new bootstrap.Collapse(collapseEl)
    );
    $(".accordions-show").removeClass("d-none");
    $(".accordions-hide").addClass("d-none");
  } else {
    $(".accordions-hide").removeClass("d-none");
    $(".accordions-show").addClass("d-none");
  }
});
$(".my-slick-2 .slick-slide").click(function () {
  slider = setInterval(function () {
    if ($(".slick-slide").width() > 100) {
      $(".modal-content").addClass("content-on");
      $(".slider-box").addClass("add-visibility");
      clearInterval(slider);
    }
  }, 400);
});

$(document).ready(function () {
  $("select").not(".contact-form-section-form select, .training-signup-form select").niceSelect();
});
let absoluteSections = [];
$(document).ready(function () {
  absoluteSections = $(".absolute-section");
  let mapAbsolutes = absoluteSections.map(myAbsolutes);
  function myAbsolutes(index) {
    let section = absoluteSections.get(index);
    let sectionText = $(section).find(".absolute__half-text");

    let setHeight = function () {
      let textHeight = $(section).find(".absolute__half-text").height();
      let imgHeight = $(section).find(".absolute__half img").height();
      let heightDifference = imgHeight - textHeight;
      if (heightDifference > 0 && $(window).width() > 575) {
        $(sectionText).css("marginBottom", heightDifference);
      }
    };
    $(".absolute__half img").on("load", setHeight);
    $(window).resize(setHeight);
  }
});

//or however you get a handle to the IMG

$(document).ready(function () {
  const slickSliders = $(".slick-container");
  const mapSliders = slickSliders.map(mySliders);

  function mySliders(index) {
    $(this)
      .children(".slick-sliders")
      .addClass("my-slick-1" + index);
    $(this)
      .find(".slick-arrow-prev")
      .addClass("slick-arrow-prev" + index);
    $(this)
      .find(".slick-arrow-next")
      .addClass("slick-arrow-next" + index);
    $(this)
      .children(".slick-sliders.my-slick")
      .slick({
        infinite: true,
        dots: true,
        slidesToScroll: 1,
        prevArrow: $(".slick-arrow-prev" + index),
        nextArrow: $(".slick-arrow-next" + index),
        responsive: [
          {
            breakpoint: 767,
            settings: {
              dots: false,
            },
          },
        ],
      });
    $(this)
      .children(".slick-sliders.my-slick-2")
      .slick({
        infinite: true,
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        focusOnSelect: true,
        asNavFor: ".my-slick-4",
        prevArrow: $(".slick-arrow-prev" + index),
        nextArrow: $(".slick-arrow-next" + index),
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              autoplay: false,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              autoplay: true,
              autoplaySpeed: 2000,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    $(this)
      .children(".slick-sliders.my-slick-5")
      .slick({
        infinite: true,
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        focusOnSelect: true,
        prevArrow: $(".slick-arrow-prev" + index),
        nextArrow: $(".slick-arrow-next" + index),
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              autoplay: false,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              autoplay: true,
              autoplaySpeed: 2000,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    $(this)
      .children(".slick-sliders.my-slick-3")
      .slick({
        infinite: true,
        arrows: true,
        prevArrow: $(".slick-arrow-prev" + index),
        nextArrow: $(".slick-arrow-next" + index),
      });
    $(this)
      .children(".slick-sliders.my-slick-4")
      .slick({
        infinite: true,
        arrows: true,
        slidesToScroll: 1,
        asNavFor: ".my-slick-2",
        prevArrow: $(".slick-arrow-prev" + index),
        nextArrow: $(".slick-arrow-next" + index),
      });
  }
});

$(document).ready(function () {
  if ($(".contact__adresses").is(":visible")) {
    let ems = $(".contact__adresses").find("em");
    $(ems).parent().parent().css("lineHeight", "1");
  }
});
let datesArray = [];
$(document).ready(function () {
  const slideDates = $(".slick-slide:not(.slick-cloned) h3");
  const mapSlides = slideDates.map(slides);
  function slides(index) {
    datesArray[index] = $(this).text();
  }
  const historyDates = $(".slick-dots button");
  const mapDates = historyDates.map(dates);
  function dates(index) {
    $(this).text(datesArray[index]);
  }
});
// Initialize and add the map
function initMap() {
  // The location of localization

  const localization = { lat: 52.35378527224951, lng: 16.89045052991007 };
  // The map, centered at localization
  const map = new google.maps.Map(document.getElementById("map"), {
    zoom: 15,
    center: localization,
    disableDefaultUI: true,
    styles: [
      {
        featureType: "poi",
        stylers: [{ visibility: "off" }], // Turn off POI.
      },
      {
        featureType: "transit.station",
        stylers: [{ visibility: "off" }], // Turn off bus, train stations etc.
      },
    ],
  });

  var image = "../assets/img/local-icon.jpg";
  // The marker, positioned at localization
  const marker = new google.maps.Marker({
    position: localization,
    map: map,
    icon: {
      path: "M25.015 2.4c-7.8 0-14.121 6.204-14.121 13.854 0 7.652 14.121 32.746 14.121 32.746s14.122-25.094 14.122-32.746c0-7.65-6.325-13.854-14.122-13.854z",
      fillColor: "black",
      scale: 0.4,
      fillOpacity: 1,
      strokeWeight: 1,
      strokeColor: "black",
      anchor: new google.maps.Point(10, 27),
    },
  });
}
$(document).ready(function () {
  $(".search__input").on("focus", function () {
    $(".search").addClass("active");
    $(".search-opener").addClass("active");
  });
  $(".search__input").on("blur", function () {
    $(".search").removeClass("active");
    $(".search-opener").removeClass("active");
  });
});
window.initMap = initMap;

$(function () {
  function closeLangDropdown() {
    $(".lang-selector .lang-dropdown").removeClass("show");
    $(".lang-selector .lang-btn").attr("aria-expanded", "false");
  }

  function closePartnerAccountPanel() {
    const $panel = $("#partner-account-panel");
    const $btn = $("#partner-account-btn");

    if (!$panel.length || $panel.prop("hidden")) {
      return;
    }

    $panel.prop("hidden", true);
    $btn.attr("aria-expanded", "false");
  }

  function closeSearchOverlay() {
    $("#search-modal").removeClass("active").attr("aria-hidden", "true");
  }

  function openSearchOverlay() {
    closeLangDropdown();
    closePartnerAccountPanel();
    $("#search-modal").addClass("active").attr("aria-hidden", "false");
    window.setTimeout(function () {
      $("#search-modal .search-modal-field").trigger("focus");
    }, 50);
  }

  $(document).on("click", ".lost", function (e) {
    e.preventDefault();
    $(".login-panel--reset").removeClass("is-hidden");
    $(".login-panel--login").addClass("is-hidden");
  });

  $(document).on("click", ".login-back", function (e) {
    e.preventDefault();
    $(".login-panel--login").removeClass("is-hidden");
    $(".login-panel--reset").addClass("is-hidden");
  });

  $(document).on("click", ".password-toggle", function (e) {
    e.preventDefault();
    const $btn = $(this);
    const $input = $btn.siblings("input");
    const isHidden = $input.attr("type") === "password";

    $input.attr("type", isHidden ? "text" : "password");
    $btn.text(isHidden ? "Ukryj" : "Pokaż");
    $btn.attr("aria-pressed", isHidden ? "true" : "false");
    $btn.attr("aria-label", isHidden ? "Ukryj hasło" : "Pokaż hasło");
  });

  const mobileLangLabels = {
    PL: "Polski (PL)",
    EN: "English (EN)",
    DE: "Deutsch (DE)",
  };

  $(document).on("click", ".lang-selector .lang-btn", function (e) {
    e.preventDefault();
    e.stopPropagation();
    const $selector = $(this).closest(".lang-selector");
    const $dropdown = $selector.find(".lang-dropdown");
    const isOpen = $dropdown.hasClass("show");

    closeLangDropdown();

    if (!isOpen) {
      closeSearchOverlay();
      closePartnerAccountPanel();
      $dropdown.addClass("show");
      $(this).attr("aria-expanded", "true");
    }
  });

  $(document).on("click", ".lang-selector .lang-dropdown button", function (e) {
    e.preventDefault();
    e.stopPropagation();
    const lang = $(this).data("lang");
    const $selector = $(this).closest(".lang-selector");

    $selector.find(".auth-lang-current, .lang-current").first().text(lang);
    $selector.find(".mobile-menu-lang-current").text(mobileLangLabels[lang] || lang);
    $selector.find(".lang-dropdown button").removeClass("is-active").attr("aria-selected", "false");
    $(this).addClass("is-active").attr("aria-selected", "true");
    $selector.find(".lang-dropdown").removeClass("show");
    $selector.find(".lang-btn").attr("aria-expanded", "false");
  });

  $(document).on("click", function (e) {
    if ($(e.target).closest(".lang-selector").length) {
      return;
    }

    closeLangDropdown();
  });

  (function initPartnerAccountPanel() {
    const $btn = $("#partner-account-btn");
    const $panel = $("#partner-account-panel");
    if (!$btn.length || !$panel.length) {
      return;
    }

    const mobileQuery = window.matchMedia("(max-width: 1200px)");

    function closePartnerAccount(restoreFocus) {
      if ($panel.prop("hidden")) {
        return;
      }

      $panel.prop("hidden", true);
      $btn.attr("aria-expanded", "false");

      if (restoreFocus) {
        $btn.trigger("focus");
      }
    }

    function openPartnerAccount() {
      closeLangDropdown();
      closeSearchOverlay();
      $panel.prop("hidden", false);
      $btn.attr("aria-expanded", "true");

      window.requestAnimationFrame(function () {
        $panel.find("a").first().trigger("focus");
      });
    }

    $btn.on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (mobileQuery.matches) {
        const $mobileMenu = $("#mobile-menu");
        const $mobilePartner = $mobileMenu.find(".mobile-menu-partner");

        if (!$mobileMenu.hasClass("active")) {
          $(".js-menu-toggle").trigger("click");
        }

        window.requestAnimationFrame(function () {
          if ($mobilePartner.length) {
            $mobilePartner[0].scrollIntoView({ block: "start", behavior: "smooth" });
            $mobilePartner.find("a").first().trigger("focus");
          }
        });
        return;
      }

      if ($panel.prop("hidden")) {
        openPartnerAccount();
      } else {
        closePartnerAccount(true);
      }
    });

    $(document).on("click", function (e) {
      if ($panel.prop("hidden")) {
        return;
      }

      if ($panel[0].contains(e.target) || $btn[0].contains(e.target)) {
        return;
      }

      closePartnerAccount($panel[0].contains(document.activeElement));
    });
  })();

  (function initMegaMenu() {
    const mqDesktop = window.matchMedia("(min-width: 1201px)");
    let closeTimer = null;

    function updateMegaTilesScrollbar($wrap) {
      const viewport = $wrap.find(".mega-tiles-viewport")[0];
      const $track = $wrap.find(".mega-tiles-scrollbar");
      const $thumb = $wrap.find(".mega-tiles-scrollbar-thumb");

      if (!viewport || !$track.length || !$thumb.length) {
        return;
      }

      const maxScroll = viewport.scrollWidth - viewport.clientWidth;

      if (maxScroll <= 1) {
        $track.addClass("is-hidden");
        $wrap.find(".mega-tiles-viewport").removeClass("is-scrollable");
        return;
      }

      $track.removeClass("is-hidden");
      $wrap.find(".mega-tiles-viewport").addClass("is-scrollable");

      const trackWidth = $track.innerWidth();
      const thumbWidth = Math.max(
        Math.round((viewport.clientWidth / viewport.scrollWidth) * trackWidth),
        48
      );
      const maxOffset = Math.max(trackWidth - thumbWidth, 0);
      const offset = maxScroll > 0 ? (viewport.scrollLeft / maxScroll) * maxOffset : 0;

      $thumb.css({
        width: thumbWidth + "px",
        left: offset + "px",
      });
    }

    function bindMegaTilesScrollbar($wrap) {
      const viewport = $wrap.find(".mega-tiles-viewport")[0];
      const $viewport = $wrap.find(".mega-tiles-viewport");
      const $track = $wrap.find(".mega-tiles-scrollbar");
      const $thumb = $wrap.find(".mega-tiles-scrollbar-thumb");

      if (!viewport || !$track.length || !$thumb.length) {
        return;
      }

      $viewport.off(".megaScroll").on("scroll.megaScroll", function () {
        updateMegaTilesScrollbar($wrap);
      });

      $thumb.off(".megaScroll").on("mousedown.megaScroll", function (e) {
        e.preventDefault();
        e.stopPropagation();

        const startX = e.clientX;
        const startScroll = viewport.scrollLeft;
        const maxScroll = viewport.scrollWidth - viewport.clientWidth;
        const trackWidth = $track.innerWidth();
        const thumbWidth = $thumb.outerWidth();
        const maxOffset = Math.max(trackWidth - thumbWidth, 0);

        $thumb.addClass("is-dragging");

        function onMove(ev) {
          const deltaX = ev.clientX - startX;
          const scrollDelta = maxOffset > 0 ? (deltaX / maxOffset) * maxScroll : 0;
          viewport.scrollLeft = Math.max(0, Math.min(maxScroll, startScroll + scrollDelta));
        }

        function onUp() {
          $thumb.removeClass("is-dragging");
          $(document).off(".megaScrollDrag");
        }

        $(document).on("mousemove.megaScrollDrag", onMove).on("mouseup.megaScrollDrag", onUp);
      });

      $track.off("click.megaScroll").on("click.megaScroll", function (e) {
        if ($(e.target).closest(".mega-tiles-scrollbar-thumb").length) {
          return;
        }

        const maxScroll = viewport.scrollWidth - viewport.clientWidth;
        const trackRect = $track[0].getBoundingClientRect();
        const clickX = e.clientX - trackRect.left;
        const thumbWidth = $thumb.outerWidth();
        const trackWidth = $track.innerWidth();
        const targetOffset = Math.max(0, Math.min(clickX - thumbWidth / 2, trackWidth - thumbWidth));
        const maxOffset = Math.max(trackWidth - thumbWidth, 0);

        viewport.scrollLeft = maxOffset > 0 ? (targetOffset / maxOffset) * maxScroll : 0;
      });
    }

    function bindMegaTilesDragScroll($wrap) {
      const viewport = $wrap.find(".mega-tiles-viewport")[0];

      if (!viewport || viewport.dataset.megaDragBound === "true") {
        return;
      }

      viewport.dataset.megaDragBound = "true";

      let activePointerId = null;
      let startX = 0;
      let startScroll = 0;
      let dragged = false;

      function onPointerMove(e) {
        if (activePointerId === null || e.pointerId !== activePointerId) {
          return;
        }

        const deltaX = e.clientX - startX;

        if (!dragged && Math.abs(deltaX) > 8) {
          dragged = true;
          viewport.classList.add("is-dragging");
        }

        if (!dragged) {
          return;
        }

        e.preventDefault();

        const maxScroll = viewport.scrollWidth - viewport.clientWidth;
        viewport.scrollLeft = Math.max(0, Math.min(maxScroll, startScroll - deltaX));
        updateMegaTilesScrollbar($wrap);
      }

      function endDrag(e) {
        if (activePointerId === null || e.pointerId !== activePointerId) {
          return;
        }

        activePointerId = null;
        viewport.classList.remove("is-dragging");

        document.removeEventListener("pointermove", onPointerMove);
        document.removeEventListener("pointerup", endDrag);
        document.removeEventListener("pointercancel", endDrag);

        if (dragged) {
          viewport.dataset.megaDragPreventClick = "true";
          window.setTimeout(function () {
            delete viewport.dataset.megaDragPreventClick;
          }, 100);
        }
      }

      viewport.addEventListener("pointerdown", function (e) {
        if (e.pointerType === "mouse" && e.button !== 0) {
          return;
        }

        if (e.target.closest(".mega-tiles-scrollbar")) {
          return;
        }

        activePointerId = e.pointerId;
        startX = e.clientX;
        startScroll = viewport.scrollLeft;
        dragged = false;

        document.addEventListener("pointermove", onPointerMove, { passive: false });
        document.addEventListener("pointerup", endDrag);
        document.addEventListener("pointercancel", endDrag);
      });

      viewport.addEventListener(
        "click",
        function (e) {
          if (viewport.dataset.megaDragPreventClick === "true") {
            e.preventDefault();
            e.stopImmediatePropagation();
          }
        },
        true
      );
    }

    function updatePanelMegaTilesScrollbars($panel) {
      $panel.find(".mega-tiles-wrap").each(function () {
        updateMegaTilesScrollbar($(this));
      });
    }

    function initMegaTilesScrollbars() {
      $(".mega-tiles-wrap").each(function () {
        const $wrap = $(this);
        bindMegaTilesScrollbar($wrap);
        bindMegaTilesDragScroll($wrap);
        updateMegaTilesScrollbar($wrap);
      });
    }

    $(window).on("resize", initMegaTilesScrollbars);
    initMegaTilesScrollbars();

    function openMegaMenu(menuId) {
      clearTimeout(closeTimer);
      $(".mega-menu-panel").removeClass("active");
      $(".desktop-menu .has-mega-menu").removeClass("is-open");
      $(".desktop-menu-trigger").attr("aria-expanded", "false");
      $(".mega-menu-panels").attr("aria-hidden", "true");

      const $item = $('.has-mega-menu[data-menu-id="' + menuId + '"]');
      const $panel = $('.mega-menu-panel[data-menu-id="' + menuId + '"]');

      if (!$item.length || !$panel.length) {
        return;
      }

      $item.addClass("is-open");
      $panel.addClass("active");
      $item.find(".desktop-menu-trigger").attr("aria-expanded", "true");
      $(".mega-menu-panels").attr("aria-hidden", "false");
      window.requestAnimationFrame(function () {
        updatePanelMegaTilesScrollbars($panel);
      });
    }

    function closeMegaMenu() {
      $(".mega-menu-panel").removeClass("active");
      $(".desktop-menu .has-mega-menu").removeClass("is-open");
      $(".desktop-menu-trigger").attr("aria-expanded", "false");
      $(".mega-menu-panels").attr("aria-hidden", "true");
    }

    function scheduleCloseMegaMenu() {
      clearTimeout(closeTimer);
      closeTimer = window.setTimeout(closeMegaMenu, 120);
    }

    $(document).on("mouseenter", ".has-mega-menu", function () {
      if (!mqDesktop.matches) {
        return;
      }
      openMegaMenu($(this).data("menu-id"));
    });

    $(document).on("mouseleave", ".has-mega-menu", scheduleCloseMegaMenu);

    $(document).on("mouseenter", ".mega-menu-panel", function () {
      if (!mqDesktop.matches) {
        return;
      }
      openMegaMenu($(this).data("menu-id"));
    });

    $(document).on("mouseleave", ".mega-menu-panel", scheduleCloseMegaMenu);

    $(document).on("focusin", ".desktop-menu-trigger", function () {
      if (!mqDesktop.matches) {
        return;
      }
      openMegaMenu($(this).data("menu-id"));
    });

    $(document).on("keydown", ".desktop-menu-trigger", function (e) {
      if (e.key === "Escape") {
        closeMegaMenu();
        $(this).trigger("blur");
      }
    });

    mqDesktop.addEventListener("change", function () {
      closeMegaMenu();
    });
  })();

  $(document).on("click", ".mobile-menu-card-toggle", function () {
    const $toggle = $(this);
    const isOpen = $toggle.closest(".mobile-menu-card").hasClass("is-open");
    const $section = $toggle.closest(".mobile-menu-section");

    $section.find(".mobile-menu-card").removeClass("is-open");
    $section.find(".mobile-menu-card-toggle").attr("aria-expanded", "false");

    if (!isOpen) {
      $toggle.closest(".mobile-menu-card").addClass("is-open");
      $toggle.attr("aria-expanded", "true");
    }
  });

  $(document).on("click", ".mobile-menu-row-toggle", function () {
    const $toggle = $(this);
    const isOpen = $toggle.closest(".mobile-menu-row").hasClass("is-open");
    const $section = $toggle.closest(".mobile-menu-section");

    $section.find(".mobile-menu-row").removeClass("is-open");
    $section.find(".mobile-menu-row-toggle").attr("aria-expanded", "false");

    if (!isOpen) {
      $toggle.closest(".mobile-menu-row").addClass("is-open");
      $toggle.attr("aria-expanded", "true");
    }
  });

  function closeMobileMenu() {
    $(".js-menu-toggle").removeClass("active").attr("aria-expanded", "false");
    $("#mobile-menu").removeClass("active").attr("aria-hidden", "true");
    $("body").removeClass("menu-open");
  }

  const mqDesktopNav = window.matchMedia("(min-width: 1201px)");

  mqDesktopNav.addEventListener("change", function () {
    if (mqDesktopNav.matches) {
      closeMobileMenu();
    }
  });

  $(document).on("click", ".js-menu-toggle", function () {
    if (mqDesktopNav.matches) {
      return;
    }

    const $btn = $(this);
    const isOpen = $("#mobile-menu").hasClass("active");

    if (!isOpen) {
      closeSearchOverlay();
      closeLangDropdown();
      closePartnerAccountPanel();
    }

    $btn.toggleClass("active", !isOpen).attr("aria-expanded", !isOpen);
    $("#mobile-menu").toggleClass("active", !isOpen).attr("aria-hidden", isOpen);
    $("body").toggleClass("menu-open", !isOpen);
  });

  $(document).on("click", ".mobile-menu-overlay a", function () {
    closeMobileMenu();
  });

  $(document).on("click", ".js-search-open", function (e) {
    e.stopPropagation();

    if ($("#search-modal").hasClass("active")) {
      closeSearchOverlay();
      return;
    }

    openSearchOverlay();
  });

  $(document).on("click", ".js-search-close", function () {
    closeSearchOverlay();
  });

  $(document).on("click", function (e) {
    if (!$("#search-modal").hasClass("active")) {
      return;
    }

    if (
      !$(e.target).closest(".search-modal-dialog").length &&
      !$(e.target).closest(".js-search-open").length
    ) {
      closeSearchOverlay();
    }
  });

  $(document).on("keydown", function (e) {
    if (e.key === "Escape") {
      closeSearchOverlay();
      closeLangDropdown();
      closePartnerAccountPanel();
      $(".mega-menu-panel").removeClass("active");
      $(".desktop-menu .has-mega-menu").removeClass("is-open");
      $(".desktop-menu-trigger").attr("aria-expanded", "false");
      $(".mega-menu-panels").attr("aria-hidden", "true");
      closeMobileMenu();
    }
  });

  const authValidators = {
    required($field) {
      const $input = $field.find("input, select, textarea").not('[type="checkbox"]').first();
      const value = $input.is("select") ? $input.val() : $input.val().trim();
      if (!value) {
        return $field.data("errorRequired") || "To pole jest wymagane.";
      }
      return "";
    },
    email($field) {
      const value = $field.find("input").val().trim();
      if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        return $field.data("errorEmail") || "Podaj prawidłowy adres e-mail.";
      }
      return "";
    },
    password($field) {
      const value = $field.find("input").val();
      if (value && value.length < 8) {
        return $field.data("errorPassword") || "Hasło musi mieć co najmniej 8 znaków.";
      }
      return "";
    },
    passwordConfirm($field) {
      const $form = $field.closest("form");
      const value = $field.find("input").val();
      const password = $form.find('[name="password"]').val();
      if (value && value !== password) {
        return $field.data("errorPasswordConfirm") || "Hasła nie są identyczne.";
      }
      return "";
    },
    requiredCheckbox($field) {
      const $checkbox = $field.find('input[type="checkbox"]').first();
      if (!$checkbox.is(":checked")) {
        return $field.data("errorRequiredCheckbox") || "To pole jest wymagane.";
      }
      return "";
    },
    noDigits($field) {
      const value = $field.find("input").val().trim();
      if (value && /\d/.test(value)) {
        return $field.data("errorNoDigits") || "To pole nie może zawierać cyfr.";
      }
      return "";
    },
    digitsOnly($field) {
      const value = $field.find("input").val().trim();
      if (value && !/^\d+$/.test(value)) {
        return $field.data("errorDigitsOnly") || "Numer telefonu może zawierać wyłącznie cyfry.";
      }
      return "";
    },
    requiredFile($field) {
      const $input = $field.find('input[type="file"]').first();
      const $form = $field.closest("form");
      const element = $form.data("element");

      if ($form.hasClass("form_cv") && element !== undefined) {
        const hiddenFile = $form.find(".file_cv_" + element).val();
        if (hiddenFile) {
          return "";
        }
      }

      if (!$input.length || !$input[0].files || !$input[0].files.length) {
        return $field.data("errorRequired") || "Załącz plik CV.";
      }
      return "";
    },
  };

  function validateAuthField($field) {
    const rules = ($field.data("validate") || "").split("|").filter(Boolean);
    let message = "";

    rules.some(function (rule) {
      const validator = authValidators[rule];
      if (!validator) {
        return false;
      }
      message = validator($field);
      return Boolean(message);
    });

    $field.toggleClass("is-invalid", Boolean(message));
    $field.find(".form-error").text(message);
    return !message;
  }

  function validateAuthForm($form) {
    let isValid = true;

    $form.find(".form-field[data-validate]").each(function () {
      if (!validateAuthField($(this))) {
        isValid = false;
      }
    });

    return isValid;
  }

  $(document).on("blur", ".auth-form .form-field[data-validate] input, .auth-form .form-field[data-validate] select", function () {
    validateAuthField($(this).closest(".form-field"));
  });

  $(document).on("change", '.auth-form .form-field[data-validate] input[type="checkbox"]', function () {
    validateAuthField($(this).closest(".form-field"));
  });

  $(document).on("input", ".auth-form .form-field.is-invalid input, .auth-form .form-field.is-invalid select", function () {
    validateAuthField($(this).closest(".form-field"));
  });

  $(document).on("input", '.auth-form [name="first_name"], .auth-form [name="last_name"]', function () {
    const sanitized = this.value.replace(/\d/g, "");
    if (sanitized !== this.value) {
      this.value = sanitized;
    }
    validateAuthField($(this).closest(".form-field"));
  });

  $(document).on("input", '.auth-form [name="phone"]', function () {
    const sanitized = this.value.replace(/\D/g, "");
    if (sanitized !== this.value) {
      this.value = sanitized;
    }
    validateAuthField($(this).closest(".form-field"));
  });

  $(document).on("submit", ".auth-form", function (e) {
    if (!validateAuthForm($(this))) {
      e.preventDefault();
      const $firstInvalid = $(this).find(".form-field.is-invalid").first();
      $firstInvalid.find("input, select, textarea").first().trigger("focus");
    }
  });

  function validateCareerCvField($field) {
    return validateAuthField($field);
  }

  function validateCareerCvForm($form) {
    let isValid = true;

    $form.find(".form-field[data-validate]").each(function () {
      if (!validateCareerCvField($(this))) {
        isValid = false;
      }
    });

    return isValid;
  }

  function initCareerCvUploads() {
    document.querySelectorAll(".career-cv-form").forEach(function (form) {
      const uploadField = form.querySelector(".form-field--upload");
      const upload = uploadField ? uploadField.querySelector(".career-cv-upload") : null;
      const fileInput = upload ? upload.querySelector('input[type="file"]') : null;
      const label = upload ? upload.querySelector(".career-cv-upload-label") : null;

      if (!upload || !fileInput || !label) {
        return;
      }

      const defaultLabel = label.textContent.trim();

      function syncUploadState() {
        const hasFile = fileInput.files && fileInput.files.length > 0;
        upload.classList.toggle("has-file", hasFile);
        label.textContent = hasFile ? fileInput.files[0].name : defaultLabel;

        if (uploadField && uploadField.classList.contains("is-invalid") && hasFile) {
          validateCareerCvField($(uploadField));
        }
      }

      fileInput.addEventListener("change", syncUploadState);

      ["dragenter", "dragover"].forEach(function (eventName) {
        upload.addEventListener(eventName, function (e) {
          e.preventDefault();
          e.stopPropagation();
          upload.classList.add("is-dragover");
        });
      });

      ["dragleave", "drop"].forEach(function (eventName) {
        upload.addEventListener(eventName, function (e) {
          e.preventDefault();
          e.stopPropagation();
          upload.classList.remove("is-dragover");
        });
      });

      upload.addEventListener("drop", function (e) {
        const files = e.dataTransfer ? e.dataTransfer.files : null;
        if (!files || !files.length) {
          return;
        }

        if (typeof DataTransfer !== "undefined") {
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(files[0]);
          fileInput.files = dataTransfer.files;
        } else {
          return;
        }

        syncUploadState();
        fileInput.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  }

  initCareerCvUploads();

  $(document).on(
    "blur",
    ".career-cv-form .form-field[data-validate] input:not([type='checkbox']):not([type='file']), .career-cv-form .form-field[data-validate] select",
    function () {
      validateCareerCvField($(this).closest(".form-field"));
    }
  );

  $(document).on("change", '.career-cv-form .form-field[data-validate] input[type="checkbox"]', function () {
    validateCareerCvField($(this).closest(".form-field"));
  });

  $(document).on("change", '.career-cv-form .form-field--upload input[type="file"]', function () {
    validateCareerCvField($(this).closest(".form-field"));
  });

  $(document).on("input", ".career-cv-form .form-field.is-invalid input:not([type='checkbox']):not([type='file'])", function () {
    validateCareerCvField($(this).closest(".form-field"));
  });

  $(document).on("submit", ".career-cv-form", function (e) {
    if (!validateCareerCvForm($(this))) {
      e.preventDefault();
      const $firstInvalid = $(this).find(".form-field.is-invalid").first();
      const $focusTarget = $firstInvalid.find("input:not([type='checkbox']), select, textarea").first();
      if ($focusTarget.length) {
        $focusTarget.trigger("focus");
      } else {
        $firstInvalid.find('input[type="checkbox"]').first().trigger("focus");
      }
    }
  });

  function validateContactFormField($field) {
    return validateAuthField($field);
  }

  function validateContactForm($form) {
    const $categoryInput = $form.find('[name="category"]');
    const $categoryError = $form.find(".contact-form-category-error");
    let isValid = true;

    if (!$categoryInput.val()) {
      const categoryMessage =
        $form.data("errorCategory") || "Wybierz rodzaj sprawy, aby wysłać formularz.";
      if ($categoryError.length) {
        $categoryError.text(categoryMessage).addClass("is-visible").prop("hidden", false);
      }
      isValid = false;
    } else if ($categoryError.length) {
      $categoryError.removeClass("is-visible").prop("hidden", true).text("");
    }

    $form.find('.contact-form-fields:not([hidden]) .form-field[data-validate]').each(function () {
      if (!validateContactFormField($(this))) {
        isValid = false;
      }
    });

    $form.find(".contact-form-contact-fields .form-field[data-validate]").each(function () {
      if (!validateContactFormField($(this))) {
        isValid = false;
      }
    });

    $form.find('.contact-form-stage .form-field--consent[data-validate]').each(function () {
      if (!validateContactFormField($(this))) {
        isValid = false;
      }
    });

    return isValid;
  }

  function getContactFormScrollPadding() {
    return 40;
  }

  function scrollContactFormStage(stage, instant) {
    if (!stage) {
      return;
    }

    const reducedMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    const headerOffset =
      parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--header-height")) || 75;
    const scrollPadding = getContactFormScrollPadding();
    const scrollBehavior = instant || reducedMotionQuery.matches ? "auto" : "smooth";

    function performScroll() {
      const scrollTarget = stage.querySelector(".contact-form-selected-bar") || stage;
      const scrollTop =
        scrollTarget.getBoundingClientRect().top + window.scrollY - headerOffset - scrollPadding;

      window.scrollTo({
        top: Math.max(0, scrollTop),
        behavior: scrollBehavior,
      });
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(performScroll);
    });
  }

  function getContactCategoryIdFromHash(hash) {
    if (!hash || hash === "#") {
      return null;
    }

    const raw = decodeURIComponent(hash.replace(/^#/, ""));

    if (raw === "formularz-kontaktowy") {
      return null;
    }

    if (raw.startsWith("kontakt-")) {
      return raw.slice("kontakt-".length);
    }

    if (raw.startsWith("contact-")) {
      return raw.slice("contact-".length);
    }

    return raw;
  }

  function findContactCategoryButton(formEl, categoryId) {
    if (!categoryId) {
      return null;
    }

    const normalized = categoryId.toLowerCase();

    return (
      Array.from(formEl.querySelectorAll(".contact-form-category")).find(function (button) {
        return (button.dataset.category || "").toLowerCase() === normalized;
      }) || null
    );
  }

  function updateContactFormHash(categoryId) {
    if (!categoryId || !window.history || !window.history.replaceState) {
      return;
    }

    const hash = "#" + categoryId;

    if (window.location.hash !== hash) {
      window.history.replaceState(null, "", hash);
    }
  }

  function resetContactFormHash() {
    if (!window.history || !window.history.replaceState) {
      return;
    }

    const hash = "#formularz-kontaktowy";

    if (window.location.hash !== hash) {
      window.history.replaceState(null, "", hash);
    }
  }

  const contactFormHashHandlers = [];

  function initContactFormSections() {
    document.querySelectorAll(".contact-form-section-form").forEach(function (formEl) {
      const categoryButtons = formEl.querySelectorAll(".contact-form-category");
      const categoryInput = formEl.querySelector('[name="category"]');
      const notificationEmailInput = formEl.querySelector('[name="notificationEmail"]');
      const stage = formEl.querySelector(".contact-form-stage");
      const fieldPanels = formEl.querySelectorAll(".contact-form-fields");
      const categoryError = formEl.querySelector(".contact-form-category-error");
      const selectedLabel = formEl.querySelector(".contact-form-selected-label");
      const statusTitle = formEl.querySelector(".contact-form-status-title");
      const statusDesc = formEl.querySelector(".contact-form-status-desc");
      const changeBtn = formEl.querySelector(".contact-form-change-btn");

      function clearValidation() {
        formEl.querySelectorAll(".form-field.is-invalid").forEach(function (field) {
          field.classList.remove("is-invalid");
          const error = field.querySelector(".form-error");
          if (error) {
            error.textContent = "";
          }
        });
      }

      function resetCategory() {
        if (categoryInput) {
          categoryInput.value = "";
        }

        if (notificationEmailInput) {
          notificationEmailInput.value = "";
        }

        const questionInput = formEl.querySelector('[name="question"]');
        if (questionInput) {
          questionInput.value = "";
        }

        categoryButtons.forEach(function (button) {
          button.classList.remove("is-active");
          button.setAttribute("aria-checked", "false");
        });

        fieldPanels.forEach(function (panel) {
          panel.hidden = true;
        });

        if (stage) {
          stage.hidden = true;
        }

        if (categoryError) {
          categoryError.classList.remove("is-visible");
          categoryError.hidden = true;
          categoryError.textContent = "";
        }

        clearValidation();
        resetContactFormHash();
      }

      function showCategory(button, shouldScroll, instantScroll) {
        const id = button.dataset.category;
        if (!categoryInput || !id) {
          return;
        }

        categoryInput.value = id;

        if (notificationEmailInput) {
          notificationEmailInput.value = button.dataset.notificationEmail || "";
        }

        const questionInput = formEl.querySelector('[name="question"]');
        if (questionInput) {
          questionInput.value = button.dataset.questionId || "";
        }

        categoryButtons.forEach(function (item) {
          const isActive = item.dataset.category === id;
          item.classList.toggle("is-active", isActive);
          item.setAttribute("aria-checked", isActive ? "true" : "false");
        });

        fieldPanels.forEach(function (panel) {
          panel.hidden = panel.dataset.categoryFields !== id;
        });

        if (selectedLabel) {
          selectedLabel.textContent = button.dataset.categoryTitle || "";
        }

        if (statusTitle) {
          statusTitle.textContent = button.dataset.stageTitle || button.dataset.categoryTitle || "";
        }

        if (statusDesc) {
          statusDesc.textContent = button.dataset.stageDescription || "";
          statusDesc.hidden = !button.dataset.stageDescription;
        }

        if (stage) {
          stage.hidden = false;
        }

        if (categoryError) {
          categoryError.classList.remove("is-visible");
          categoryError.hidden = true;
          categoryError.textContent = "";
        }

        clearValidation();
        updateContactFormHash(id);

        if (shouldScroll !== false && stage) {
          scrollContactFormStage(stage, instantScroll);
        }
      }

      categoryButtons.forEach(function (button) {
        button.addEventListener("click", function () {
          showCategory(button);
        });
      });

      if (changeBtn) {
        changeBtn.addEventListener("click", function () {
          resetCategory();
          formEl.querySelector(".contact-form-category-picker").scrollIntoView({
            behavior: "smooth",
            block: "nearest",
          });
        });
      }

      contactFormHashHandlers.push(function (categoryId, shouldScroll, instantScroll) {
        const button = findContactCategoryButton(formEl, categoryId);
        if (button) {
          showCategory(button, shouldScroll, instantScroll);
        }
      });
    });

    function applyContactFormHash(shouldScroll, instantScroll) {
      const categoryId = getContactCategoryIdFromHash(window.location.hash);
      if (!categoryId) {
        return;
      }

      contactFormHashHandlers.forEach(function (handler) {
        handler(categoryId, shouldScroll, instantScroll);
      });
    }

    function scrollToActiveContactFormStage(instantScroll) {
      document.querySelectorAll(".contact-form-section-form .contact-form-stage:not([hidden])").forEach(function (stage) {
        scrollContactFormStage(stage, instantScroll);
      });
    }

    const initialCategoryHash = getContactCategoryIdFromHash(window.location.hash);
    if (initialCategoryHash) {
      applyContactFormHash(false, false);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          scrollToActiveContactFormStage(true);
        });
      });
    }

    if (!window.__contactFormHashListener) {
      window.__contactFormHashListener = true;
      window.addEventListener("hashchange", function () {
        applyContactFormHash(true, false);
      });
    }
  }

  initContactFormSections();

  $(document).on(
    "blur",
    ".contact-form-section-form .contact-form-fields:not([hidden]) .form-field[data-validate] input:not([type='checkbox']), .contact-form-section-form .contact-form-fields:not([hidden]) .form-field[data-validate] select, .contact-form-section-form .contact-form-fields:not([hidden]) .form-field[data-validate] textarea, .contact-form-section-form .contact-form-stage:not([hidden]) .contact-form-contact-fields .form-field[data-validate] input:not([type='checkbox']), .contact-form-section-form .contact-form-stage:not([hidden]) .contact-form-contact-fields .form-field[data-validate] select, .contact-form-section-form .contact-form-stage:not([hidden]) .contact-form-contact-fields .form-field[data-validate] textarea",
    function () {
      validateContactFormField($(this).closest(".form-field"));
    }
  );

  $(document).on("change", '.contact-form-section-form .form-field[data-validate] input[type="checkbox"], .contact-form-section-form .form-field[data-validate] select', function () {
    validateContactFormField($(this).closest(".form-field"));
  });

  $(document).on("input", ".contact-form-section-form .form-field.is-invalid input:not([type='checkbox']), .contact-form-section-form .form-field.is-invalid textarea", function () {
    validateContactFormField($(this).closest(".form-field"));
  });

  $(document).on("submit", ".contact-form-section-form", function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    const $form = $(this);

    if (!validateContactForm($form)) {
      const $firstInvalid = $form.find(".form-field.is-invalid").first();
      if ($firstInvalid.length) {
        $firstInvalid.find("input, select, textarea").first().trigger("focus");
      } else {
        $form.find(".contact-form-category").first().trigger("focus");
      }
      return;
    }

    const $submitBtn = $form.find(".contact-form-submit");
    const $success = $form.find(".contact-form-success");
    const formData = new FormData(this);
    let submitted = false;

    $submitBtn.prop("disabled", true);

    $.ajax({
      url: $form.attr("action"),
      method: "POST",
      data: formData,
      processData: false,
      contentType: false,
      dataType: "json",
      success: function (response) {
        submitted = true;
        $form.addClass("is-submitted");
        $form.find(".contact-form-stage").prop("hidden", true);
        $form.find(".contact-form-category-picker").prop("hidden", true);
        $form.find(".contact-form-section-intro").prop("hidden", true);
        $submitBtn.prop("hidden", true);

        if ($success.length) {
          const fallbackMessage = $success.text().trim();
          let message = fallbackMessage;

          if (typeof response === "string" && response.trim() !== "") {
            message = response.trim();
          } else if (response && typeof response.message === "string" && response.message.trim() !== "") {
            message = response.message.trim();
          }

          $success.text(message).prop("hidden", false).addClass("is-visible");

          if ($success[0] && typeof $success[0].scrollIntoView === "function") {
            $success[0].scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      },
      error: function () {
        $submitBtn.prop("disabled", false);
      },
      complete: function () {
        if (!submitted) {
          $submitBtn.prop("disabled", false);
        }
      },
    });
  });
});
const button = document.querySelectorAll(".my-slick-2 .slick-slide");
let mousedownTime;

$(".my-slick-2 .slick-slide").mousedown(function () {
  mousedownTime = new Date().getTime();
});
$(".my-slick-2 .slick-slide").mouseup(function () {
  const mouseupTime = new Date().getTime();
  timeDifference = mouseupTime - mousedownTime;
  if (timeDifference < 350) {
    $(".modal-slider").modal("show");
  }
});
$(".btn-close-slider").click(function () {
  $(".modal-slider").modal("hide");
});

$(document).ready(function () {
  $(".map__image").removeClass("active");
  if ($("input[id='flexRadioDefault1']").is(":checked")) {
    $(".map__image--profix").addClass("active");
  } else {
    $(".map__image--simplex").addClass("active");
  }

  initGlobalReachMap();
});

function initGlobalReachMap() {
  document.querySelectorAll("[data-global-reach-map]").forEach(function (section) {
    const buttons = section.querySelectorAll("[data-map-brand]");
    const images = section.querySelectorAll("[data-map-image]");
    if (!buttons.length || !images.length) {
      return;
    }

    function setActiveBrand(brandId) {
      buttons.forEach(function (button) {
        const isActive = button.dataset.mapBrand === brandId;
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-pressed", isActive ? "true" : "false");
      });

      images.forEach(function (image) {
        image.classList.toggle("is-active", image.dataset.mapImage === brandId);
      });
    }

    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        setActiveBrand(button.dataset.mapBrand);
      });
    });

    const defaultButton =
      section.querySelector("[data-map-brand].is-active") || buttons[0];
    if (defaultButton) {
      setActiveBrand(defaultButton.dataset.mapBrand);
    }
  });
}
$(".map__changer").click(function () {
  $(".map__image").removeClass("active");
});
$(".map__changer--blue").click(function () {
  $(".map__image--profix").addClass("active");
});
$(".map__changer--yellow").click(function () {
  $(".map__image--simplex").addClass("active");
});
var prevScrollpos = window.pageYOffset;
window.onscroll = function () {
  var currentScrollPos = window.pageYOffset;
  if (
    prevScrollpos < currentScrollPos &&
    currentScrollPos > $(".banner").height()
  ) {
    $(".search").removeClass("open");
    $(".search-opener").removeClass("active");

    // if ($(".search").hasClass("open")) {
    //   setTimeout(function () {
    //     $("#navbar").addClass("hide");
    //     $(".header__container").removeClass("header__container--active");
    //     $(".hamburger").removeClass("hamburger--active");
    //   }, 600);
    // } else {
    $("#navbar").addClass("hide");
    $(".header__container").removeClass("header__container--active");
    $(".hamburger").removeClass("hamburger--active");
    // }
  } else {
    $("#navbar").removeClass("hide");
  }
  prevScrollpos = currentScrollPos;
};

var sParallax = document.getElementsByClassName("sparallax");
new simpleParallax(sParallax, {
  delay: 0.6,
  transition: ".35,.13,.59,.82",
  scale: 1.15,
});
var shapesParallax = document.getElementsByClassName("shapesparallax");
new simpleParallax(shapesParallax, {
  delay: 1,
  transition: ".35,.13,.59,.82",
  scale: 2.8,
});

var scaleUp = document.getElementsByClassName("sparallax-scale-up");
new simpleParallax(scaleUp, {
  delay: 0.8,
  transition: ".35,.13,.59,.82",
  scale: 1.3,
});

$(document).on("click", ".list li", function () {
  if ($(this).is(".list li:first")) {
    $(".current").removeClass("color-primary");
  } else {
    $(".current").addClass("color-primary");
  }
});

$(document).ready(function () {
  if ($(".history-slider .slick-dots li").is(":visible")) {
    let dates = $(".history-slider .slick-dots li");
    if (dates.length % 2 === 0) {
      dates[dates.length - 1].classList.add("even");
    } else {
      dates[dates.length - 1].classList.add("odd");
    }
  }
});
  function toggleConsentOutsideWrapper($wrapper, $trigger) {
    if (!$wrapper.length) {
      return;
    }

    const isOpen = $wrapper.toggleClass("opened").hasClass("opened");
    $trigger.attr("aria-expanded", isOpen ? "true" : "false");
  }

  function getNewsletterConsentWrapper($copy) {
    return $copy.children(".outside-wrapper");
  }

  $(document).on("mousedown", ".newsletter-section .newsletter-consent .checkbox-copy--expandable", function (e) {
    if (e.button !== 0 || $(e.target).closest("a").length) {
      return;
    }

    e.preventDefault();
  });

  $(document).on("click", ".newsletter-section .newsletter-consent .checkbox-copy--expandable", function (e) {
    if ($(e.target).closest("a").length) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    const $copy = $(this);
    toggleConsentOutsideWrapper(getNewsletterConsentWrapper($copy), $copy);
  });

  $(document).on("keydown", ".newsletter-section .newsletter-consent .checkbox-copy--expandable", function (e) {
    if (e.key !== "Enter" && e.key !== " ") {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    const $copy = $(this);
    toggleConsentOutsideWrapper(getNewsletterConsentWrapper($copy), $copy);
  });

  $(document).on("click", ".check-opener", function (e) {
    if ($(this).closest(".newsletter-section .checkbox-copy--expandable").length) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    const $opener = $(this);
    let $wrapper = $opener.next(".outside-wrapper");
    if (!$wrapper.length) {
      $wrapper = $opener.closest(".form-field--consent, .newsletter-consent, .checkbox-d").children(".outside-wrapper");
    }
    if (!$wrapper.length) {
      $wrapper = $opener.closest(".career-cv-consent-text, .checkbox-copy, .checkbox-l").children(".outside-wrapper");
    }
    if (!$wrapper.length) {
      return;
    }

    toggleConsentOutsideWrapper($wrapper, $opener);
  });
$(document).ready(function () {
  if ($(".persons-slick").is(":visible")) {
    $(".persons-slick .slick-slide").css(
      "height",
      $(".persons-slick").height()
    );
  }
  setTimeout(function () {
    $(".history-slider .slick-slide").css(
      "height",
      $(".history-slider").height()
    );
  }, 100);
});
$(document).on("click", ".search-opener", function () {
  $(".search").toggleClass("open");
  if (!$(".search").hasClass("open")) {
    $(".search__input").blur();
  } else {
    $(".search__input").focus();
  }
});
$(document).ready(function () {
  $(document).on("click", function (event) {
    if (
      !$(event.target).closest(".search").length &&
      !$(event.target).closest(".search-opener").length
    ) {
      $(".search").removeClass("open");
    }
  });
});
(function () {
  document.querySelectorAll("[data-company-history]").forEach(function (section) {
    const panels = Array.from(section.querySelectorAll("[data-history-panel]"));
    if (!panels.length) return;

    const imgEl = section.querySelector(".company-history-img");
    const yearEl = section.querySelector(".company-history-year-display");
    const titleEl = section.querySelector(".company-history-event-title");
    const descEl = section.querySelector(".company-history-event-desc");
    const pickers = section.querySelectorAll("[data-history-picker]");
    const stageEl = section.querySelector(".company-history-stage");
    const mobileQuery = window.matchMedia("(max-width: 768px)");

    const initialIndex = Math.floor((panels.length - 1) / 2);
    let activeIndex = initialIndex;
    let ticking = false;
    let isSyncing = false;
    let scrollSettleTimer = null;
    let syncFinishTimer = null;
    let wheelAccumulator = 0;
    let wheelStepLocked = false;
    let wheelCooldownTimer = null;
    const WHEEL_STEP_THRESHOLD = 65;
    const WHEEL_UNLOCK_DELAY = 50;

    function getPanelData(index) {
      const panel = panels[index];
      if (!panel) return null;

      const imgNode = panel.querySelector("[data-history-img]");
      const titleNode = panel.querySelector("[data-history-title]");
      const descNode = panel.querySelector("[data-history-desc]");

      return {
        img: imgNode ? imgNode.getAttribute("src") || "" : "",
        imgAlt: imgNode ? imgNode.getAttribute("alt") || "" : "",
        year: panel.querySelector("[data-history-year]")?.textContent?.trim() || "",
        title: titleNode ? titleNode.innerHTML : "",
        desc: descNode ? descNode.innerHTML : "",
      };
    }

    function normalizeHistoryDesc(html) {
      if (!html || !String(html).trim()) return "";

      const wrapper = document.createElement("div");
      wrapper.innerHTML = String(html).trim();

      function isEmptyParagraph(el) {
        if (!el || el.tagName !== "P") return false;
        const text = (el.textContent || "").replace(/\u00a0/g, " ").trim();
        if (text) return false;
        const children = Array.from(el.childNodes);
        if (!children.length) return true;
        return children.every(function (node) {
          return node.nodeType === Node.ELEMENT_NODE && node.tagName === "BR";
        });
      }

      var changed = true;
      while (changed) {
        changed = false;
        var first = wrapper.firstElementChild;
        var last = wrapper.lastElementChild;
        if (first && isEmptyParagraph(first)) {
          first.remove();
          changed = true;
          continue;
        }
        if (last && last !== first && isEmptyParagraph(last)) {
          last.remove();
          changed = true;
        }
      }

      return wrapper.innerHTML.trim();
    }

    function setHistoryDesc(html) {
      if (!descEl) return;
      const normalized = normalizeHistoryDesc(html);
      descEl.innerHTML = normalized;
      descEl.hidden = !normalized;
    }

    function setActiveIndex(index, options) {
      const opts = options || {};
      if (index < 0 || index >= panels.length) return;
      if (index === activeIndex && !opts.force) return;

      activeIndex = index;
      const data = getPanelData(index);
      if (!data) return;

      if (imgEl) {
        imgEl.src = data.img;
        imgEl.alt = data.imgAlt;
      }
      if (yearEl) yearEl.textContent = data.year;
      if (titleEl) titleEl.innerHTML = data.title;
      setHistoryDesc(data.desc);

      pickers.forEach(function (picker) {
        picker.querySelectorAll("[data-history-year-btn]").forEach(function (btn) {
          const btnIndex = parseInt(btn.getAttribute("data-index"), 10);
          const isActive = btnIndex === index;
          btn.classList.toggle("is-active", isActive);
          btn.setAttribute("aria-selected", isActive ? "true" : "false");
        });
      });

      updatePickerArrows();
    }

    function updatePickerArrows() {
      pickers.forEach(function (picker) {
        if (!isPickerVisible(picker)) return;

        const prevBtn = picker.querySelector("[data-history-picker-prev]");
        const nextBtn = picker.querySelector("[data-history-picker-next]");
        const atStart = activeIndex <= 0;
        const atEnd = activeIndex >= panels.length - 1;

        if (prevBtn) prevBtn.disabled = atStart;
        if (nextBtn) nextBtn.disabled = atEnd;
      });
    }

    function getWheelDelta(event, viewport) {
      let delta = event.deltaY;

      if (event.deltaMode === 1) {
        delta *= 16;
      } else if (event.deltaMode === 2) {
        delta *= viewport ? viewport.clientHeight : 400;
      }

      return delta;
    }

    function lockWheelStepping() {
      wheelStepLocked = true;
      wheelAccumulator = 0;
    }

    function unlockWheelStepping() {
      clearTimeout(wheelCooldownTimer);
      wheelCooldownTimer = window.setTimeout(function () {
        wheelStepLocked = false;
        wheelAccumulator = 0;
      }, WHEEL_UNLOCK_DELAY);
    }

    function canStepPicker(direction) {
      const nextIndex = activeIndex + direction;
      return nextIndex >= 0 && nextIndex < panels.length;
    }

    function stepPicker(direction) {
      if (!canStepPicker(direction)) {
        wheelAccumulator = 0;
        wheelStepLocked = false;
        clearTimeout(wheelCooldownTimer);
        return false;
      }

      syncPickersToIndex(activeIndex + direction, "smooth");
      return true;
    }

    function updatePickerEdgePadding(picker) {
      const viewport = picker.querySelector("[data-history-picker-viewport]");
      const list = picker.querySelector("[data-history-picker-list]");
      const buttons = picker.querySelectorAll("[data-history-year-btn]");
      if (!viewport || !list || !buttons.length) return;

      const isVertical = picker.getAttribute("data-history-picker") === "vertical";
      const viewportSize = isVertical ? viewport.clientHeight : viewport.clientWidth;
      let maxBtnSize = 0;

      buttons.forEach(function (btn) {
        const size = isVertical ? btn.offsetHeight : btn.offsetWidth;
        if (size > maxBtnSize) maxBtnSize = size;
      });

      const edgePad = Math.max(0, (viewportSize - maxBtnSize) / 2);

      if (isVertical) {
        list.style.paddingTop = edgePad + "px";
        list.style.paddingBottom = edgePad + "px";
        list.style.paddingLeft = "0";
        list.style.paddingRight = "0";
      } else {
        list.style.paddingLeft = edgePad + "px";
        list.style.paddingRight = edgePad + "px";
      }
    }

    function updatePickerVisuals(picker) {
      const viewport = picker.querySelector("[data-history-picker-viewport]");
      const buttons = picker.querySelectorAll("[data-history-year-btn]");
      if (!viewport || !buttons.length) return activeIndex;

      const isVertical = picker.getAttribute("data-history-picker") === "vertical";
      const viewportRect = viewport.getBoundingClientRect();
      const center = isVertical
        ? viewportRect.top + viewportRect.height / 2
        : viewportRect.left + viewportRect.width / 2;

      let closestIndex = 0;
      let closestDistance = Infinity;

      buttons.forEach(function (btn) {
        const rect = btn.getBoundingClientRect();
        const btnCenter = isVertical
          ? rect.top + rect.height / 2
          : rect.left + rect.width / 2;
        const distance = Math.abs(btnCenter - center);
        const maxDistance = isVertical ? viewportRect.height / 2 : viewportRect.width / 2;
        const ratio = maxDistance ? Math.min(distance / maxDistance, 1) : 0;
        const scale = Math.max(0.62, 1 - ratio * 0.38);
        const opacity = Math.max(0.2, 1 - ratio * 0.8);

        btn.style.setProperty("--history-picker-scale", scale.toFixed(3));
        btn.style.setProperty("--history-picker-opacity", opacity.toFixed(3));

        if (distance < closestDistance) {
          closestDistance = distance;
          const dataIndex = parseInt(btn.getAttribute("data-index"), 10);
          closestIndex = isNaN(dataIndex) ? closestIndex : dataIndex;
        }
      });

      return closestIndex;
    }

    function isPickerVisible(picker) {
      return picker.offsetParent !== null && window.getComputedStyle(picker).display !== "none";
    }

    function getScrollOffsetToCenter(viewport, btn, isVertical) {
      const viewportRect = viewport.getBoundingClientRect();
      const btnRect = btn.getBoundingClientRect();

      if (isVertical) {
        return (
          viewport.scrollTop +
          (btnRect.top - viewportRect.top) +
          btnRect.height / 2 -
          viewportRect.height / 2
        );
      }

      return (
        viewport.scrollLeft +
        (btnRect.left - viewportRect.left) +
        btnRect.width / 2 -
        viewportRect.width / 2
      );
    }

    function clampScrollOffset(viewport, offset, isVertical) {
      if (isVertical) {
        const maxScroll = Math.max(0, viewport.scrollHeight - viewport.clientHeight);
        return Math.max(0, Math.min(offset, maxScroll));
      }

      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      return Math.max(0, Math.min(offset, maxScroll));
    }

    function scrollButtonIntoCenter(picker, index, behavior) {
      if (!isPickerVisible(picker)) return;

      const viewport = picker.querySelector("[data-history-picker-viewport]");
      const btn = picker.querySelector('[data-history-year-btn][data-index="' + index + '"]');
      if (!viewport || !btn) return;

      const isVertical = picker.getAttribute("data-history-picker") === "vertical";
      const offset = clampScrollOffset(
        viewport,
        getScrollOffsetToCenter(viewport, btn, isVertical),
        isVertical
      );

      if (isVertical) {
        viewport.scrollTo({ top: offset, behavior: behavior || "smooth" });
      } else {
        viewport.scrollTo({ left: offset, behavior: behavior || "smooth" });
      }
    }

    function finishPickerSync() {
      pickers.forEach(function (picker) {
        if (!isPickerVisible(picker)) return;
        scrollButtonIntoCenter(picker, activeIndex, "auto");
        updatePickerVisuals(picker);
      });
      updatePickerArrows();
      isSyncing = false;
      unlockWheelStepping();
    }

    function waitForPickerScrollEnd(behavior, callback) {
      if (behavior === "auto") {
        window.requestAnimationFrame(callback);
        return;
      }

      const viewports = [];
      pickers.forEach(function (picker) {
        if (!isPickerVisible(picker)) return;
        const viewport = picker.querySelector("[data-history-picker-viewport]");
        if (viewport) viewports.push(viewport);
      });

      if (!viewports.length) {
        callback();
        return;
      }

      let finished = false;
      let pending = viewports.length;

      const done = function () {
        if (finished) return;
        finished = true;
        clearTimeout(syncFinishTimer);
        callback();
      };

      const onViewportDone = function () {
        pending -= 1;
        if (pending <= 0) done();
      };

      viewports.forEach(function (viewport) {
        viewport.addEventListener("scrollend", onViewportDone, { once: true });
      });

      syncFinishTimer = window.setTimeout(done, 350);
    }

    function syncPickersToIndex(index, behavior) {
      if (isSyncing) return;

      const scrollBehavior = behavior || "smooth";
      isSyncing = true;
      clearTimeout(scrollSettleTimer);

      pickers.forEach(function (picker) {
        if (!isPickerVisible(picker)) return;
        updatePickerEdgePadding(picker);
        scrollButtonIntoCenter(picker, index, scrollBehavior);
        updatePickerVisuals(picker);
      });

      setActiveIndex(index, { force: true });

      waitForPickerScrollEnd(scrollBehavior, finishPickerSync);
    }

    function onPickerScroll(picker) {
      if (!isPickerVisible(picker)) return;

      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(function () {
          updatePickerVisuals(picker);
          ticking = false;
        });
      }

      if (isSyncing) return;

      clearTimeout(scrollSettleTimer);
      scrollSettleTimer = window.setTimeout(function () {
        if (isSyncing || wheelStepLocked || !isPickerVisible(picker)) return;
        const index = updatePickerVisuals(picker);
        if (index !== activeIndex) {
          syncPickersToIndex(index, "smooth");
        }
      }, 50);
    }

    function initPickers() {
      setActiveIndex(activeIndex, { force: true });
      pickers.forEach(function (picker) {
        if (!isPickerVisible(picker)) return;
        updatePickerEdgePadding(picker);
        scrollButtonIntoCenter(picker, activeIndex, "auto");
        updatePickerVisuals(picker);
      });
      updatePickerArrows();
    }

    pickers.forEach(function (picker) {
      const viewport = picker.querySelector("[data-history-picker-viewport]");
      if (!viewport) return;

      viewport.addEventListener(
        "scroll",
        function () {
          onPickerScroll(picker);
        },
        { passive: true }
      );

      viewport.addEventListener(
        "wheel",
        function (event) {
          if (!isPickerVisible(picker)) return;

          if (isSyncing || wheelStepLocked) {
            event.preventDefault();
            return;
          }

          const delta = getWheelDelta(event, viewport);
          if (!delta) return;

          if (
            wheelAccumulator !== 0 &&
            Math.sign(wheelAccumulator) !== Math.sign(delta)
          ) {
            wheelAccumulator = 0;
          }

          wheelAccumulator += delta;

          if (Math.abs(wheelAccumulator) < WHEEL_STEP_THRESHOLD) {
            event.preventDefault();
            return;
          }

          const direction = wheelAccumulator > 0 ? 1 : -1;
          wheelAccumulator = 0;

          if (!canStepPicker(direction)) {
            return;
          }

          event.preventDefault();
          lockWheelStepping();
          stepPicker(direction);
        },
        { passive: false }
      );

      picker.querySelectorAll("[data-history-year-btn]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          const index = parseInt(btn.getAttribute("data-index"), 10);
          if (isNaN(index)) return;
          syncPickersToIndex(index, "smooth");
        });
      });

      const prevBtn = picker.querySelector("[data-history-picker-prev]");
      const nextBtn = picker.querySelector("[data-history-picker-next]");

      if (prevBtn) {
        prevBtn.addEventListener("click", function () {
          stepPicker(-1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener("click", function () {
          stepPicker(1);
        });
      }
    });

    initPickers();
    window.addEventListener("resize", function () {
      window.requestAnimationFrame(initPickers);
    });

    if (stageEl) {
      const SWIPE_THRESHOLD = 48;
      const SWIPE_MAX_VERTICAL = 72;
      let touchStartX = 0;
      let touchStartY = 0;
      let touchTracking = false;

      stageEl.addEventListener(
        "touchstart",
        function (event) {
          if (!mobileQuery.matches || event.touches.length !== 1) {
            touchTracking = false;
            return;
          }

          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
          touchTracking = true;
        },
        { passive: true }
      );

      stageEl.addEventListener(
        "touchend",
        function (event) {
          if (!touchTracking || !mobileQuery.matches) {
            return;
          }

          touchTracking = false;

          const touch = event.changedTouches[0];
          if (!touch) {
            return;
          }

          const deltaX = touch.clientX - touchStartX;
          const deltaY = touch.clientY - touchStartY;

          if (Math.abs(deltaX) < SWIPE_THRESHOLD) {
            return;
          }

          if (Math.abs(deltaY) > SWIPE_MAX_VERTICAL && Math.abs(deltaY) > Math.abs(deltaX)) {
            return;
          }

          if (deltaX < 0) {
            stepPicker(1);
          } else {
            stepPicker(-1);
          }
        },
        { passive: true }
      );
    }
  });
})();
(function () {
  document.querySelectorAll("[data-support-brand]").forEach(function (component) {
    const tabs = Array.from(component.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;

    function activate(tab, moveFocus) {
      tabs.forEach(function (item) {
        const selected = item === tab;
        item.setAttribute("aria-selected", selected ? "true" : "false");
        item.tabIndex = selected ? 0 : -1;
        const panel = document.getElementById(item.getAttribute("aria-controls"));
        if (panel) panel.hidden = !selected;
      });
      if (moveFocus) tab.focus();
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener("click", function () {
        activate(tab);
      });
      tab.addEventListener("keydown", function (event) {
        if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === "Home") nextIndex = 0;
        else if (event.key === "End") nextIndex = tabs.length - 1;
        else if (event.key === "ArrowRight") nextIndex = (index + 1) % tabs.length;
        else nextIndex = (index - 1 + tabs.length) % tabs.length;
        activate(tabs[nextIndex], true);
      });
    });
  });
})();
(function () {
  const revealElements = document.querySelectorAll(".reveal");
  if (!revealElements.length) return;

  function activateReveal(element) {
    element.classList.add("active");
  }

  if ("IntersectionObserver" in window) {
    const revealObserver = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            activateReveal(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        root: null,
        threshold: 0.1,
        rootMargin: "0px 0px -40px 0px",
      }
    );

    revealElements.forEach(function (element) {
      revealObserver.observe(element);
    });
  } else {
    revealElements.forEach(activateReveal);
  }
})();
$(document).ready(function () {
  if ($(window).width() < 767) {
    console.log("dasd");
    $(".history .slick-arrow").css(
      "top",
      79 + $(".history-slider .zoom").width() * (9 / 16)
    );
  }
});
$(document).on("click", ".custom-prev", function () {
  $(".slick-sliders.my-slick").slick("slickPrev");
});
$(document).on("click", ".custom-next", function () {
  $(".slick-sliders.my-slick").slick("slickNext");
});
